/**
 * This file is auto-generated by graphql-codegen. Do not edit manually!
 * Please execute `npm run graphql-codegen` for updating the type definitions.
 */

/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigDecimal: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
  JWT: { input: any; output: any };
  TimeZone: { input: any; output: any };
  URL: { input: any; output: any };
  UUID: { input: any; output: any };
}

export interface AcceptSoftwareSubscriptionMasterAgreementAmendmentInput {
  eContractId: Scalars['ID']['input'];
}

export interface AcceptSoftwareSubscriptionMasterAgreementAmendmentPayload {
  __typename?: 'AcceptSoftwareSubscriptionMasterAgreementAmendmentPayload';
  subscriptionId: Scalars['ID']['output'];
}

export interface Account extends Node, Pageable {
  __typename?: 'Account';
  address?: Maybe<Address>;
  id: Scalars['ID']['output'];
  isCashOnly?: Maybe<Scalars['Boolean']['output']>;
  isFleet?: Maybe<Scalars['Boolean']['output']>;
  isFleetOrderingBlocked?: Maybe<Scalars['Boolean']['output']>;
  isPurchaseOrderNumberMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not provided in CCMSv2 */
  language?: Maybe<Scalars['String']['output']>;
  originId: Scalars['String']['output'];
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** This is technical field, not shown in UI - it was added for the account compound key in order to resolve reference */
  type?: Maybe<AccountType>;
}

export interface AccountConnection extends Connection {
  __typename?: 'AccountConnection';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
}

export interface AccountEdge extends Edge {
  __typename?: 'AccountEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Account;
}

export interface AccountEVoucherAdministrationConfiguration {
  __typename?: 'AccountEVoucherAdministrationConfiguration';
  maxEVoucherQuotationThresholdValue?: Maybe<Scalars['BigDecimal']['output']>;
  maxEVoucherValue?: Maybe<Money>;
  maxNumberOfValidMonths?: Maybe<Scalars['Int']['output']>;
  minQuotationValue?: Maybe<Money>;
}

export interface AccountEVoucherDetails {
  __typename?: 'AccountEVoucherDetails';
  customer?: Maybe<Customer>;
  fleetQuotationInformation?: Maybe<AccountEVoucherFleetQuotationInformation>;
  isPartiallyRedeemable?: Maybe<Scalars['Boolean']['output']>;
  isReactivatable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use AccountEVoucherDetails.redemptionsInformation */
  redemptionInformation?: Maybe<EVoucherRedemptionInformation>;
  redemptionsInformation?: Maybe<Array<EVoucherRedemptionInformation>>;
  standardQuotationInformation?: Maybe<AccountEVoucherStandardQuotationInformation>;
  totalUsedValue?: Maybe<Money>;
  type?: Maybe<AccountEVoucherType>;
  value?: Maybe<Money>;
}

export interface AccountEVoucherFleetQuotationInformation {
  __typename?: 'AccountEVoucherFleetQuotationInformation';
  estimatedExpirationDate?: Maybe<Scalars['Date']['output']>;
  maxNumberOfValidMonths?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Money>;
  monthlyFee?: Maybe<Money>;
  quotationId: Scalars['String']['output'];
  subContractId?: Maybe<Scalars['String']['output']>;
  totalFleetContractCost?: Maybe<Money>;
}

export interface AccountEVoucherStandardQuotationInformation {
  __typename?: 'AccountEVoucherStandardQuotationInformation';
  estimatedExpirationDate?: Maybe<Scalars['Date']['output']>;
  maxNumberOfValidMonths?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Money>;
  order?: Maybe<Order>;
  qualifyingQuoteValue?: Maybe<Money>;
  quotationId: Scalars['String']['output'];
  totalQuoteValue?: Maybe<Money>;
}

export enum AccountEVoucherType {
  FLEET = 'FLEET',
  STANDARD = 'STANDARD'
}

export interface AccountPaginationResult extends PaginationResult {
  __typename?: 'AccountPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Account>>;
}

export enum AccountType {
  BILL_TO = 'BILL_TO',
  SHIP_TO = 'SHIP_TO',
  SOLD_TO = 'SOLD_TO'
}

export interface Accreditor {
  __typename?: 'Accreditor';
  id: Scalars['ID']['output'];
  numberOfCredits?: Maybe<Scalars['Float']['output']>;
}

export interface ActivateCampaignEVoucherPayload {
  __typename?: 'ActivateCampaignEVoucherPayload';
  eVoucherId: Scalars['ID']['output'];
}

export interface ActivateSoftwareSubscriptionInput {
  subscriptionId: Scalars['ID']['input'];
}

export interface ActivateSoftwareSubscriptionPayload {
  __typename?: 'ActivateSoftwareSubscriptionPayload';
  subscriptionId: Scalars['ID']['output'];
}

export interface Address {
  __typename?: 'Address';
  additionalGeoCode?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  company2?: Maybe<Scalars['String']['output']>;
  company3?: Maybe<Scalars['String']['output']>;
  company4?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  /** This field should not be used directly - added for internal use to be able to extend address with i18n Country */
  countryId?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Array<Scalars['String']['output']>>;
  postalcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  /** This field should not be used directly - added for internal use to be able to extend address with i18n Region */
  regionId?: Maybe<Scalars['String']['output']>;
  streetname?: Maybe<Scalars['String']['output']>;
  streetname2?: Maybe<Scalars['String']['output']>;
  streetname3?: Maybe<Scalars['String']['output']>;
  streetname4?: Maybe<Scalars['String']['output']>;
  streetname5?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
}

export interface AddressFormattedArgs {
  formType: FormType;
  localization: LocalizationInput;
}

export enum AddressCheckWarning {
  GENERAL = 'GENERAL',
  LEVEL2 = 'LEVEL2',
  LEVEL3 = 'LEVEL3'
}

export interface AddressSuggestion {
  __typename?: 'AddressSuggestion';
  id: Scalars['ID']['output'];
  suggestion: Scalars['String']['output'];
}

export interface AddressSuggestionFilterInput {
  country?: InputMaybe<Scalars['String']['input']>;
  postalcode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
}

export interface AddToCartInput {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  fleetItems?: InputMaybe<Array<CartItemInput>>;
  localization: LocalizationInput;
  peakItems?: InputMaybe<Array<CartPeakItemInput>>;
  softwareSubscriptionItems?: InputMaybe<Array<CartSubscriptionItemInput>>;
  standardItems?: InputMaybe<Array<CartItemInput>>;
  subscriptionItems?: InputMaybe<Array<CartSubscriptionItemInput>>;
}

export interface AddToCartItemErrorPayload {
  __typename?: 'AddToCartItemErrorPayload';
  productId: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
}

export interface AddToCartItemPayload {
  __typename?: 'AddToCartItemPayload';
  hasAdjustedQuantity: Scalars['Boolean']['output'];
  product: Product;
  quantity: Scalars['Float']['output'];
}

export interface AddToCartItemPayloadProductArgs {
  localization: LocalizationInput;
}

export interface AddToCartPayload {
  __typename?: 'AddToCartPayload';
  cart: Cart;
  failedItems?: Maybe<Array<AddToCartItemErrorPayload>>;
  successfulItems?: Maybe<Array<AddToCartItemPayload>>;
}

export interface AddToShoppingListInput {
  items: Array<ShoppingListItemInput>;
  shoppingListId: Scalars['String']['input'];
}

export interface AddToShoppingListPayload {
  __typename?: 'AddToShoppingListPayload';
  items?: Maybe<Array<Maybe<ShoppingListItem>>>;
}

export interface ApplyOrderDraftEVoucherInput {
  eVoucherCode: Scalars['String']['input'];
  orderDraftId: Scalars['ID']['input'];
}

export interface ApplyOrderDraftEVoucherPayload {
  __typename?: 'ApplyOrderDraftEVoucherPayload';
  orderDraft: OrderDraft;
}

export interface ApproveFleetQuotationInput {
  quotationId: Scalars['ID']['input'];
}

export interface ApproveQuotationForRepairNotifications {
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  repairNotificationIds: Array<Scalars['String']['input']>;
}

export interface Article extends Node, Pageable {
  __typename?: 'Article';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  numberOfLikes?: Maybe<Scalars['Int']['output']>;
  numberOfViews?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the particular article in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface ArticlesPaginationResult extends PaginationResult {
  __typename?: 'ArticlesPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Article>>;
}

export interface AssignSoftwareSubscriptionContactInput {
  email: Scalars['String']['input'];
  licenseActivationCode?: InputMaybe<Scalars['String']['input']>;
  licenseGroupId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId: Scalars['ID']['input'];
}

export interface AssignSoftwareSubscriptionContactPayload {
  __typename?: 'AssignSoftwareSubscriptionContactPayload';
  user?: Maybe<LicenseUserAssignment>;
}

export interface AssignSoftwareSubscriptionContactsInput {
  emails: Array<Scalars['String']['input']>;
  licenseActivationCode: Scalars['String']['input'];
  licenseGroupId: Scalars['Int']['input'];
  subscriptionId: Scalars['ID']['input'];
}

export interface AssignSoftwareSubscriptionContactsPayload {
  __typename?: 'AssignSoftwareSubscriptionContactsPayload';
  statuses: Array<Maybe<SoftwareSubscriptionContactAssignmentStatus>>;
}

export interface Author {
  __typename?: 'Author';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface Banner extends Node {
  __typename?: 'Banner';
  body?: Maybe<Scalars['String']['output']>;
  displayDelay?: Maybe<Scalars['Int']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<BannerLayoutType>;
  links?: Maybe<Array<Link>>;
  mobileHeadline?: Maybe<Scalars['String']['output']>;
  overline?: Maybe<Scalars['String']['output']>;
  subHeadline?: Maybe<Scalars['String']['output']>;
  webAnalyticsData?: Maybe<WebAnalyticsData>;
}

export enum BannerLayoutType {
  LIFESTYLE = 'LIFESTYLE',
  NO_IMAGE = 'NO_IMAGE',
  PRODUCT = 'PRODUCT'
}

export enum BatteriesExchangeLockType {
  IMMEDIATELY = 'IMMEDIATELY',
  ON_ORDER_CREATION = 'ON_ORDER_CREATION'
}

/** The BatterySelfRecyclingDocument is a type designed specifically for retrieval of battery self-recycling documents and should not be used in any different context */
export interface BatterySelfRecyclingDocument {
  __typename?: 'BatterySelfRecyclingDocument';
  url?: Maybe<Scalars['String']['output']>;
}

export enum BillingCycle {
  FREE_OF_CHARGE = 'FREE_OF_CHARGE',
  MONTHLY = 'MONTHLY',
  SINGLE = 'SINGLE',
  YEARLY = 'YEARLY',
  YEARLY_AND_MONTHLY = 'YEARLY_AND_MONTHLY'
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface CalculateSoftwareSubscriptionPriceInput {
  calculateTax?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  subscriptionId: Scalars['ID']['input'];
  unitPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
}

export interface CalculateSoftwareSubscriptionPricePayload {
  __typename?: 'CalculateSoftwareSubscriptionPricePayload';
  currentUnitPrice?: Maybe<Money>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  price?: Maybe<Money>;
  proratedCharges?: Maybe<SubscriptionProratedCharges>;
  unitPrice?: Maybe<Money>;
}

export interface CallMeBackInput {
  country: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The user response token provided by the reCAPTCHA client-side integration. */
  token?: InputMaybe<Scalars['String']['input']>;
}

export interface CallMeBackPayload {
  __typename?: 'CallMeBackPayload';
  conversationId: Scalars['ID']['output'];
}

export interface CampaignEVoucherDetails {
  __typename?: 'CampaignEVoucherDetails';
  /** @deprecated Use TargetedCampaignEVoucherDetails.accountsFileName */
  accountsFileName?: Maybe<Scalars['String']['output']>;
  campaignType?: Maybe<EVoucherCampaignType>;
  conditionTiers: Array<EVoucherConditionTier>;
  eligibleProducts?: Maybe<EVoucherProductsSelection>;
  maxNumberOfRedemptions?: Maybe<Scalars['Int']['output']>;
  nonTargetedCampaignDetails?: Maybe<NonTargetedCampaignEVoucherDetails>;
  /** @deprecated Use TargetedCampaignEVoucherDetails.numberOfAccounts */
  numberOfAccounts?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use TargetedCampaignEVoucherDetails.numberOfContacts */
  numberOfContacts?: Maybe<Scalars['Int']['output']>;
  numberOfRedemptions?: Maybe<Scalars['Int']['output']>;
  qualifyingProducts?: Maybe<EVoucherProductsSelection>;
  remainingNumberOfRedemptions?: Maybe<Scalars['Int']['output']>;
  targetedCampaignDetails?: Maybe<TargetedCampaignEVoucherDetails>;
}

export interface CancelSoftwareSubscriptionInput {
  cancellationReason: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  subscriptionId: Scalars['ID']['input'];
}

export interface CancelSoftwareSubscriptionPayload {
  __typename?: 'CancelSoftwareSubscriptionPayload';
  softwareSubscription: SoftwareSubscription;
}

export interface Cart extends Node {
  __typename?: 'Cart';
  id: Scalars['ID']['output'];
  numberOfItems?: Maybe<Scalars['Int']['output']>;
}

export interface CartItemInput {
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
}

export interface CartPeakItemInput {
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rentalEndDate: Scalars['Date']['input'];
  rentalStartDate: Scalars['Date']['input'];
  useCurrentRentalPeriodForAllItems: Scalars['Boolean']['input'];
}

export interface CartSubscriptionItemInput {
  billingCycle: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
}

export enum CaseType {
  PROPERCASE = 'PROPERCASE',
  UPPERCASE = 'UPPERCASE'
}

export interface Category extends Node {
  __typename?: 'Category';
  /** List of subcategories */
  childCategories?: Maybe<Array<Category>>;
  /** Country isocode */
  country: Scalars['String']['output'];
  /** Category long description */
  description?: Maybe<Scalars['String']['output']>;
  /** Category id */
  id: Scalars['ID']['output'];
  /** Language isocode */
  language: Scalars['String']['output'];
  /** List of parent categories */
  path?: Maybe<Array<Category>>;
  /** URL providing category image of width: 200, height: 200 by default */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Category name */
  title?: Maybe<Scalars['String']['output']>;
}

export interface CategoryThumbnailArgs {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
}

export interface CategorySearch {
  __typename?: 'CategorySearch';
  id: Scalars['ID']['output'];
  parent?: Maybe<CategorySearch>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface ChangeToolCostCenterInput {
  comboChildren?: InputMaybe<Array<ChangeToolCostCenterInput>>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  productThumbnail?: InputMaybe<Scalars['String']['input']>;
  productTitle: Scalars['String']['input'];
  toolEquipmentNumber: Scalars['String']['input'];
}

export interface ChangeToolLabelsInput {
  comboChildren?: InputMaybe<Array<ChangeToolLabelsInput>>;
  inventoryNumber: Scalars['String']['input'];
  organizationalReference: Scalars['String']['input'];
  productThumbnail?: InputMaybe<Scalars['String']['input']>;
  productTitle: Scalars['String']['input'];
  toolEquipmentNumber: Scalars['String']['input'];
}

export interface ChangeToolsCostCenterInput {
  tools: Array<ChangeToolCostCenterInput>;
}

export interface ChangeToolsLabelsInput {
  tools: Array<ChangeToolLabelsInput>;
}

export interface CheckAddressInput {
  caseType?: InputMaybe<CaseType>;
  country: Scalars['String']['input'];
  language: Scalars['String']['input'];
  postalcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetname?: InputMaybe<Scalars['String']['input']>;
  streetname2?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
}

export interface CheckAddressPayload {
  __typename?: 'CheckAddressPayload';
  originalAddress?: Maybe<Address>;
  suggestedAddress?: Maybe<Address>;
  warningCode?: Maybe<AddressCheckWarning>;
}

export interface CheckoutStoreConfiguration {
  __typename?: 'CheckoutStoreConfiguration';
  completeDelivery?: Maybe<Scalars['Boolean']['output']>;
  customerDeliveryDateMonthLimit?: Maybe<Scalars['Int']['output']>;
  customerFleetQuoteConversion?: Maybe<Scalars['Boolean']['output']>;
  customerStandardQuoteConversion?: Maybe<Scalars['Boolean']['output']>;
  employeeDeliveryDateMonthLimit?: Maybe<Scalars['Int']['output']>;
  employeeFleetOrder?: Maybe<Scalars['Boolean']['output']>;
  employeeFleetQuoteConversion?: Maybe<Scalars['Boolean']['output']>;
  maxDiscountDeterminationRules?: Maybe<Array<Maybe<MaxDiscountDeterminationRule>>>;
  purchaseOrderDocument?: Maybe<Scalars['Boolean']['output']>;
  purchaseOrderDocumentMandatory?: Maybe<Scalars['Boolean']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['Boolean']['output']>;
  purchaseOrderNumberValidation?: Maybe<Scalars['Boolean']['output']>;
  quickQuoteConversion?: Maybe<Scalars['Boolean']['output']>;
  requestedDeliveryDateDaysAfter?: Maybe<Scalars['Int']['output']>;
  requestedDeliveryDateDaysBefore?: Maybe<Scalars['Int']['output']>;
}

export interface CircularityReport extends Node, Pageable {
  __typename?: 'CircularityReport';
  id: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
}

export interface CircularityReportsPaginationResult extends PaginationResult {
  __typename?: 'CircularityReportsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<CircularityReport>>;
}

export interface CommonStoreConfiguration {
  __typename?: 'CommonStoreConfiguration';
  addressCheck?: Maybe<Scalars['Boolean']['output']>;
  addressCheckCaseType?: Maybe<CaseType>;
  calendar?: Maybe<Scalars['Boolean']['output']>;
  callMeBack?: Maybe<Scalars['Boolean']['output']>;
  employeeCareNoteCreation?: Maybe<Scalars['Boolean']['output']>;
  financialHubLimitedCapabilities?: Maybe<Scalars['Boolean']['output']>;
  fireStopSubmittals?: Maybe<Scalars['Boolean']['output']>;
  liveChat?: Maybe<Scalars['Boolean']['output']>;
  personalInformationConsent?: Maybe<Scalars['Boolean']['output']>;
  recentlyPurchasedItems?: Maybe<Scalars['Boolean']['output']>;
  recommendedProducts?: Maybe<Scalars['Boolean']['output']>;
  restrictedDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  sendUsAMessage?: Maybe<Scalars['Boolean']['output']>;
  shipmentTracking?: Maybe<Scalars['Boolean']['output']>;
  softwareSubscriptionManagement?: Maybe<Scalars['Boolean']['output']>;
  storeLocator?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use storeWeeklyOpeningSchedule query instead */
  weeklyOpeningSchedule?: Maybe<WeeklyOpeningSchedule>;
}

export enum CompletionStatus {
  FULL = 'FULL',
  NONE = 'NONE',
  PARTIAL = 'PARTIAL'
}

export interface Connection {
  edges: Array<Edge>;
  pageInfo: PageInfo;
}

export interface ConsumablesSubscription extends Node, Pageable {
  __typename?: 'ConsumablesSubscription';
  billingCycle: BillingCycle;
  cancellationDate?: Maybe<Scalars['DateTime']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  creditCardDetails?: Maybe<CreditCardDetails>;
  id: Scalars['ID']['output'];
  newRecurringPrice?: Maybe<Money>;
  newRecurringPriceEffectiveMonth?: Maybe<Month>;
  paymentTerm?: Maybe<PaymentTerms>;
  recurringPrice?: Maybe<Money>;
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  type?: Maybe<ConsumablesSubscriptionType>;
}

export interface ConsumablesSubscriptionMonthlyUsage extends Pageable {
  __typename?: 'ConsumablesSubscriptionMonthlyUsage';
  budget?: Maybe<Money>;
  id: Scalars['ID']['output'];
  monthEndDate?: Maybe<Scalars['Date']['output']>;
  monthStartDate?: Maybe<Scalars['Date']['output']>;
  usedAmount?: Maybe<Money>;
}

export interface ConsumablesSubscriptionMonthlyUsageOrderByInput {
  billingPeriod?: InputMaybe<Sort>;
  budget?: InputMaybe<Sort>;
  usedAmount?: InputMaybe<Sort>;
}

export interface ConsumablesSubscriptionMonthlyUsagePaginationResult extends PaginationResult {
  __typename?: 'ConsumablesSubscriptionMonthlyUsagePaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<ConsumablesSubscriptionMonthlyUsage>;
}

export interface ConsumablesSubscriptionPaginationResult extends PaginationResult {
  __typename?: 'ConsumablesSubscriptionPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<ConsumablesSubscription>>;
}

export interface ConsumablesSubscriptionProductUsage extends Pageable {
  __typename?: 'ConsumablesSubscriptionProductUsage';
  costCenter?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationalReference?: Maybe<Scalars['String']['output']>;
  product: Product;
  productFamily?: Maybe<ProductFamily>;
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  purchaseQuantity?: Maybe<Scalars['Int']['output']>;
  usedAmount?: Maybe<Money>;
}

export interface ConsumablesSubscriptionProductUsageProductArgs {
  localization: LocalizationInput;
}

export interface ConsumablesSubscriptionProductUsageOrderByInput {
  productFamily?: InputMaybe<Sort>;
  productId?: InputMaybe<Sort>;
  purchaseDate?: InputMaybe<Sort>;
  quantity?: InputMaybe<Sort>;
  usedAmount?: InputMaybe<Sort>;
}

export interface ConsumablesSubscriptionProductUsagePaginationResult extends PaginationResult {
  __typename?: 'ConsumablesSubscriptionProductUsagePaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<ConsumablesSubscriptionProductUsage>;
}

export interface ConsumablesSubscriptionTotalUsage {
  __typename?: 'ConsumablesSubscriptionTotalUsage';
  averageBudget?: Maybe<Money>;
  averageUsageAmount?: Maybe<Money>;
  totalBudget?: Maybe<Money>;
  totalUsageAmount?: Maybe<Money>;
  usageAmountByProductFamily?: Maybe<Array<ProductFamilyUsage>>;
}

export enum ConsumablesSubscriptionType {
  CONSOPASS = 'CONSOPASS'
}

export interface ConsumablesSubscriptionUsageFilterInput {
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  organizationalReferences?: InputMaybe<Array<Scalars['String']['input']>>;
  productFamilies?: InputMaybe<Array<ProductFamily>>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseOrderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface ConsumablesSubscriptionUsageFilters {
  __typename?: 'ConsumablesSubscriptionUsageFilters';
  costCenters?: Maybe<Array<Scalars['String']['output']>>;
  organizationalReferences?: Maybe<Array<Scalars['String']['output']>>;
  productFamilies?: Maybe<Array<ProductFamily>>;
  productIds?: Maybe<Array<Scalars['ID']['output']>>;
  purchaseOrderNumbers?: Maybe<Array<Scalars['String']['output']>>;
}

export interface Contact extends Node, Pageable {
  __typename?: 'Contact';
  academicTitle?: Maybe<ContactAcademicTitle>;
  authorizedForHiltiOnline?: Maybe<Scalars['Boolean']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formatted?: Maybe<Array<Scalars['String']['output']>>;
  function?: Maybe<ContactFunction>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  originId: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<ContactTitle>;
}

export interface ContactFormattedArgs {
  formType: FormType;
  localization: LocalizationInput;
}

export interface ContactAcademicTitle extends Localizable {
  __typename?: 'ContactAcademicTitle';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface ContactAcademicTitleNameArgs {
  localization: LocalizationInput;
}

export interface ContactConnection extends Connection {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  pageInfo: PageInfo;
}

export interface ContactEdge extends Edge {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Contact;
}

export interface ContactFunction extends Localizable {
  __typename?: 'ContactFunction';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface ContactFunctionNameArgs {
  localization: LocalizationInput;
}

export interface ContactsAssignableToSubscriptionInput {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface ContactsAssignableToSubscriptionPayload {
  __typename?: 'ContactsAssignableToSubscriptionPayload';
  emailsAssignable?: Maybe<Array<Scalars['String']['output']>>;
  emailsNotAssignable?: Maybe<Array<Scalars['String']['output']>>;
}

export interface ContactTitle extends Localizable {
  __typename?: 'ContactTitle';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface ContactTitleNameArgs {
  localization: LocalizationInput;
}

export interface CopyCompanyToPrivateShoppingListInput {
  companyShoppingListId: Scalars['String']['input'];
  privateShoppingList: CreatePrivateShoppingListInput;
}

export interface CopyCompanyToPrivateShoppingPayload {
  __typename?: 'CopyCompanyToPrivateShoppingPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface CopyPrivateToCompanyShoppingListInput {
  companyShoppingList: CreateCompanyShoppingListInput;
  privateShoppingListId: Scalars['String']['input'];
}

export interface CopyPrivateToCompanyShoppingPayload {
  __typename?: 'CopyPrivateToCompanyShoppingPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface Country extends Localizable {
  __typename?: 'Country';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface CountryNameArgs {
  localization: LocalizationInput;
}

export interface CreateAccountEVoucherInput {
  eVoucherValue: Scalars['BigDecimal']['input'];
  quotationId: Scalars['String']['input'];
  type: AccountEVoucherType;
}

export interface CreateAccountEVoucherPayload {
  __typename?: 'CreateAccountEVoucherPayload';
  eVoucher: EVoucher;
}

export interface CreateCampaignEVoucherInput {
  campaignType?: InputMaybe<EVoucherCampaignType>;
  eVoucherCode: Scalars['String']['input'];
}

export interface CreateCampaignEVoucherPayload {
  __typename?: 'CreateCampaignEVoucherPayload';
  eVoucher: EVoucher;
}

export interface CreateCartInput {
  localization: LocalizationInput;
}

export interface CreateCartPayload {
  __typename?: 'CreateCartPayload';
  cart: Cart;
}

export interface CreateCompanyShoppingListInput {
  accountId: Scalars['String']['input'];
  contactId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface CreateContactInput {
  academicTitle?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  function: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateContactPayload {
  __typename?: 'CreateContactPayload';
  contact?: Maybe<Contact>;
}

export interface CreateCustomerCareNoteInput {
  complaint: Scalars['String']['input'];
  expectation: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceDeliveryNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateEContractInput {
  eContractView: EContractViewInput;
  templateId: Scalars['ID']['input'];
}

export interface CreateLegacySoftwareSubscriptionMasterAgreementInput {
  subscriptionId: Scalars['ID']['input'];
}

export interface CreateLegacySoftwareSubscriptionMasterAgreementPayload {
  __typename?: 'CreateLegacySoftwareSubscriptionMasterAgreementPayload';
  eContract?: Maybe<EContract>;
}

export interface CreateOrderDraftFromQuotationInput {
  isFleetQuotation?: InputMaybe<Scalars['Boolean']['input']>;
  quotationId: Scalars['ID']['input'];
}

export interface CreateOrderDraftFromQuotationPayload {
  __typename?: 'CreateOrderDraftFromQuotationPayload';
  isEligibleForQuickCheckout?: Maybe<Scalars['Boolean']['output']>;
  orderDraftId: Scalars['ID']['output'];
}

export interface CreatePrivateShoppingListInput {
  contactId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface CreateShippingAddressInput {
  additionalGeoCode?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company2?: InputMaybe<Scalars['String']['input']>;
  company3?: InputMaybe<Scalars['String']['input']>;
  company4?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  oneTimePassword?: InputMaybe<Scalars['String']['input']>;
  postalcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetname?: InputMaybe<Scalars['String']['input']>;
  streetname2?: InputMaybe<Scalars['String']['input']>;
  streetname3?: InputMaybe<Scalars['String']['input']>;
  streetname4?: InputMaybe<Scalars['String']['input']>;
  streetname5?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateShippingAddressPayload {
  __typename?: 'CreateShippingAddressPayload';
  shippingAddress?: Maybe<Account>;
}

export interface CreateShoppingListPayload {
  __typename?: 'CreateShoppingListPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface CreateSoftwareSubscriptionMasterAgreementAmendmentInput {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  subscriptionId: Scalars['ID']['input'];
  subscriptionVersion: Scalars['Int']['input'];
  unitPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
}

export interface CreateSoftwareSubscriptionMasterAgreementAmendmentPayload {
  __typename?: 'CreateSoftwareSubscriptionMasterAgreementAmendmentPayload';
  eContract?: Maybe<EContract>;
}

export interface CreditCardDetails {
  __typename?: 'CreditCardDetails';
  expirationDate: Scalars['Date']['output'];
  holderName?: Maybe<Scalars['String']['output']>;
  lastDigits: Scalars['String']['output'];
  type: CreditCardType;
}

export enum CreditCardType {
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  MASTERCARD = 'MASTERCARD',
  OTHER = 'OTHER',
  VISA = 'VISA'
}

export interface CurrencyExchangeRate {
  __typename?: 'CurrencyExchangeRate';
  exchangeRateFrom?: Maybe<Scalars['Float']['output']>;
  exchangeRateTo?: Maybe<Scalars['Float']['output']>;
}

export interface Customer extends Node, UserContext {
  __typename?: 'Customer';
  companyAccount: Account;
  contact: Contact;
  defaultBillToAccount?: Maybe<Account>;
  defaultShipToAccount?: Maybe<Account>;
  email: Scalars['String']['output'];
  fleetMasterContract?: Maybe<FleetMasterContract>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  /** This is the role assigned to the customer coming from the HC-Claim-HOL-Permissions header token. The default value for the role is 'buyer'. */
  role?: Maybe<Scalars['String']['output']>;
}

export interface CustomerFleetMasterContractArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNote extends Pageable {
  __typename?: 'CustomerCareNote';
  afterMarketServiceNotificationNumber?: Maybe<Scalars['String']['output']>;
  careNoteClass?: Maybe<CustomerCareNoteClass>;
  careNoteSubtype?: Maybe<CustomerCareNoteSubtype>;
  careNoteType?: Maybe<CustomerCareNoteType>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  complaint?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCareNotificationNumber?: Maybe<Scalars['String']['output']>;
  disputedValue?: Maybe<Money>;
  employeeClosedBy?: Maybe<Scalars['String']['output']>;
  employeeHandledBy?: Maybe<Scalars['String']['output']>;
  employeeReceivedBy?: Maybe<Scalars['String']['output']>;
  employeeRecordedBy?: Maybe<Scalars['String']['output']>;
  expectation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  referenceDeliveryNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomerCareNoteStatus>;
  tasks?: Maybe<Array<Maybe<CustomerCareNoteTask>>>;
  toolSerialNumber?: Maybe<Scalars['String']['output']>;
}

export interface CustomerCareNoteClass extends Localizable {
  __typename?: 'CustomerCareNoteClass';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface CustomerCareNoteClassNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteOrderByInput {
  afterMarketServiceNotificationNumber?: InputMaybe<Sort>;
  careNoteClass?: InputMaybe<Sort>;
  careNoteSubtype?: InputMaybe<Sort>;
  careNoteType?: InputMaybe<Sort>;
  closedAt?: InputMaybe<Sort>;
  contact?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  customerCareNotificationNumber?: InputMaybe<Sort>;
  customerNumber?: InputMaybe<Sort>;
  disputedCurrency?: InputMaybe<Sort>;
  disputedValue?: InputMaybe<Sort>;
  employeeClosedBy?: InputMaybe<Sort>;
  employeeHandledBy?: InputMaybe<Sort>;
  employeeReceivedBy?: InputMaybe<Sort>;
  employeeRecordedBy?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  invoiceNumber?: InputMaybe<Sort>;
  orderNumber?: InputMaybe<Sort>;
  productId?: InputMaybe<Sort>;
  purchaseOrderNumber?: InputMaybe<Sort>;
  receivedAt?: InputMaybe<Sort>;
  referenceDeliveryNumber?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  toolSerialNumber?: InputMaybe<Sort>;
}

export interface CustomerCareNotePaginationResult extends PaginationResult {
  __typename?: 'CustomerCareNotePaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<CustomerCareNote>>;
}

export interface CustomerCareNotePayload {
  __typename?: 'CustomerCareNotePayload';
  careNote: CustomerCareNote;
}

export interface CustomerCareNoteStatus extends Localizable {
  __typename?: 'CustomerCareNoteStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface CustomerCareNoteStatusNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteSubtype extends Localizable {
  __typename?: 'CustomerCareNoteSubtype';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface CustomerCareNoteSubtypeNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteTask {
  __typename?: 'CustomerCareNoteTask';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  employeeClosedBy?: Maybe<Scalars['String']['output']>;
  employeeCreatedBy?: Maybe<Scalars['String']['output']>;
  employeeDoneBy?: Maybe<Scalars['String']['output']>;
  employeeUpdatedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  responsibleDepartment?: Maybe<Department>;
  responsiblePerson?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomerCareNoteTaskStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface CustomerCareNoteTaskStatus extends Localizable {
  __typename?: 'CustomerCareNoteTaskStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface CustomerCareNoteTaskStatusNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteType extends Localizable {
  __typename?: 'CustomerCareNoteType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface CustomerCareNoteTypeNameArgs {
  localization: LocalizationInput;
}

export interface CustomerEVoucherRestrictions {
  __typename?: 'CustomerEVoucherRestrictions';
  isAllowedToUseAccountEVouchers?: Maybe<Scalars['Boolean']['output']>;
  isAllowedToUseCampaignEVouchers?: Maybe<Scalars['Boolean']['output']>;
}

export interface CustomerPricesFilterInput {
  currency?: InputMaybe<Scalars['String']['input']>;
  products: Array<ProductPriceInput>;
  shipToAccountId?: InputMaybe<Scalars['String']['input']>;
  types: Array<PriceType>;
}

export enum CustomerServiceMessageStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum CustomerType {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL'
}

export interface DailyOpeningSchedule {
  __typename?: 'DailyOpeningSchedule';
  day: Day;
  open?: Maybe<Scalars['Boolean']['output']>;
  workingHours?: Maybe<Array<TimeRange>>;
}

export enum Day {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export interface DeactivateEVoucherPayload {
  __typename?: 'DeactivateEVoucherPayload';
  eVoucherId: Scalars['ID']['output'];
}

export interface DeclineSoftwareSubscriptionMasterAgreementAmendmentInput {
  eContractId: Scalars['ID']['input'];
}

export interface DeclineSoftwareSubscriptionMasterAgreementAmendmentPayload {
  __typename?: 'DeclineSoftwareSubscriptionMasterAgreementAmendmentPayload';
  subscriptionId: Scalars['ID']['output'];
}

export interface DelayedBillingInformation {
  __typename?: 'DelayedBillingInformation';
  months?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<DelayedBillingReason>;
}

export enum DelayedBillingReason {
  SALES_TACTICS = 'SALES_TACTICS'
}

export interface DeleteOrderDraftPurchaseOrderDocumentInput {
  orderDraftId: Scalars['ID']['input'];
  purchaseOrderDocumentId: Scalars['String']['input'];
}

export interface DeleteOrderDraftPurchaseOrderDocumentPayload {
  __typename?: 'DeleteOrderDraftPurchaseOrderDocumentPayload';
  orderDraft: OrderDraft;
}

export interface DeleteShoppingListPayload {
  __typename?: 'DeleteShoppingListPayload';
  id: Scalars['ID']['output'];
}

export interface DeleteSoftwareSubscriptionInput {
  subscriptionId: Scalars['ID']['input'];
}

export interface DeleteSoftwareSubscriptionPayload {
  __typename?: 'DeleteSoftwareSubscriptionPayload';
  subscriptionId: Scalars['ID']['output'];
}

export interface DeliveryInformation {
  __typename?: 'DeliveryInformation';
  carrierInstructions?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  isSingleShipment?: Maybe<Scalars['Boolean']['output']>;
}

export interface DeliveryMethod extends Localizable {
  __typename?: 'DeliveryMethod';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface DeliveryMethodNameArgs {
  localization: LocalizationInput;
}

export interface DeliveryMethodShippingDetails {
  __typename?: 'DeliveryMethodShippingDetails';
  calculationInProgress?: Maybe<Scalars['Boolean']['output']>;
  dates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  deliveryMethod: DeliveryMethod;
  hasApproximatedShippingCharges?: Maybe<Scalars['Boolean']['output']>;
  isAllowedToChooseDeliveryDate?: Maybe<Scalars['Boolean']['output']>;
  maxRequestDeliveryDate?: Maybe<Scalars['Date']['output']>;
  minRequestDeliveryDate?: Maybe<Scalars['Date']['output']>;
  shippingCharges?: Maybe<Money>;
}

export interface DeliveryStatus extends Localizable {
  __typename?: 'DeliveryStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface DeliveryStatusNameArgs {
  localization: LocalizationInput;
}

export interface DeliveryType {
  __typename?: 'DeliveryType';
  id: Scalars['ID']['output'];
}

export interface Department extends Localizable {
  __typename?: 'Department';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface DepartmentNameArgs {
  localization: LocalizationInput;
}

export interface Dimension {
  __typename?: 'Dimension';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface Discount {
  __typename?: 'Discount';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['BigDecimal']['output']>;
  value?: Maybe<Scalars['BigDecimal']['output']>;
}

export enum DistanceUnit {
  KM = 'KM',
  MI = 'MI'
}

export interface EContract extends Node {
  __typename?: 'EContract';
  fields?: Maybe<Array<EContractField>>;
  id: Scalars['ID']['output'];
  iframeUrl?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
}

export interface EContractField extends Node {
  __typename?: 'EContractField';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<EContractFieldValidation>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface EContractFieldInput {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface EContractFieldValidation {
  __typename?: 'EContractFieldValidation';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
}

export interface EContractIframeUrlInput {
  eContractId: Scalars['ID']['input'];
  returnUri: Scalars['String']['input'];
}

export interface EContractPayload {
  __typename?: 'EContractPayload';
  eContract: EContract;
}

export interface EContractTemplate extends Node {
  __typename?: 'EContractTemplate';
  fields?: Maybe<Array<EContractField>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface EContractViewInput {
  fields?: InputMaybe<Array<EContractFieldInput>>;
  isViewPortEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  returnUri: Scalars['String']['input'];
}

export interface Edge {
  cursor?: Maybe<Scalars['String']['output']>;
  node: Node;
}

export interface EducationSeries extends Node, Pageable {
  __typename?: 'EducationSeries';
  /** Accreditor details for the series */
  accreditor?: Maybe<Accreditor>;
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of the video in seconds */
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  numberOfChapters?: Maybe<Scalars['Int']['output']>;
  /** The part of the URL that identifies the particular series in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface EducationSeriesPaginationResult extends PaginationResult {
  __typename?: 'EducationSeriesPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<EducationSeries>>;
}

export interface EducationTeaser extends Node {
  __typename?: 'EducationTeaser';
  body?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  linkUri: Scalars['String']['output'];
}

export interface EducationTutorial extends Node, Pageable {
  __typename?: 'EducationTutorial';
  description?: Maybe<Scalars['String']['output']>;
  /** Duration of the video in seconds */
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  numberOfViews?: Maybe<Scalars['Int']['output']>;
  /** The part of the URL that identifies the particular series in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface EducationTutorialsPaginationResult extends PaginationResult {
  __typename?: 'EducationTutorialsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<EducationTutorial>>;
}

export interface Employee extends Node, UserContext {
  __typename?: 'Employee';
  customerCompanyAccount?: Maybe<Account>;
  customerContact?: Maybe<Contact>;
  customerFleetMasterContract?: Maybe<FleetMasterContract>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role?: Maybe<Role>;
  type?: Maybe<EmployeeType>;
}

export interface EmployeeCustomerFleetMasterContractArgs {
  localization: LocalizationInput;
}

export enum EmployeeType {
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  EVOUCHER_BACKOFFICE_USER = 'EVOUCHER_BACKOFFICE_USER'
}

export interface EntryPriceInformation {
  __typename?: 'EntryPriceInformation';
  pricePerUnit?: Maybe<Money>;
  priceQuantity?: Maybe<Scalars['Float']['output']>;
  priceUnitOfMeasure?: Maybe<UnitOfMeasure>;
  totalPrice?: Maybe<Money>;
}

export interface EVoucher extends Node, Pageable {
  __typename?: 'EVoucher';
  accountDetails?: Maybe<AccountEVoucherDetails>;
  campaignDetails?: Maybe<CampaignEVoucherDetails>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<EVoucherStatus>;
  type: EVoucherType;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
}

export interface EVoucherAccountsAdministrationConfiguration {
  __typename?: 'EVoucherAccountsAdministrationConfiguration';
  accountRestrictedAccounts: Array<Account>;
  campaignRestrictedAccounts: Array<Account>;
}

export interface EVoucherAdministrationConfiguration {
  __typename?: 'EVoucherAdministrationConfiguration';
  fleetAccountEVoucherAdministrationConfiguration?: Maybe<AccountEVoucherAdministrationConfiguration>;
  fleetAccountEVoucherEligibleProductsInformation?: Maybe<EVoucherProductSelectionInformation>;
  numberOfAccountEVoucherRestrictedAccounts?: Maybe<Scalars['Int']['output']>;
  numberOfCampaignEVoucherRestrictedAccounts?: Maybe<Scalars['Int']['output']>;
  restrictedProductInformation?: Maybe<EVoucherProductSelectionInformation>;
  standardAccountEVoucherAdministrationConfiguration?: Maybe<AccountEVoucherAdministrationConfiguration>;
  standardAccountEVoucherEligibleProductsInformation?: Maybe<EVoucherProductSelectionInformation>;
}

export interface EVoucherCampaignReportState {
  __typename?: 'EVoucherCampaignReportState';
  creationDate?: Maybe<Scalars['Date']['output']>;
  /** This field contains information if final version of the report is available, if true no more report generation requests are allowed */
  isFinalVersionAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** This field contains information if report is generating in current point in time */
  isNewVersionBeingGenerated?: Maybe<Scalars['Boolean']['output']>;
}

export enum EVoucherCampaignType {
  NON_TARGETED = 'NON_TARGETED',
  TARGETED = 'TARGETED'
}

export interface EVoucherConditionTier {
  __typename?: 'EVoucherConditionTier';
  cartTotal?: Maybe<Scalars['BigDecimal']['output']>;
  discount?: Maybe<Discount>;
  productsValue?: Maybe<Scalars['BigDecimal']['output']>;
}

export interface EVoucherFilterInput {
  query?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<Array<EVoucherFilterRestriction>>;
  type?: InputMaybe<EVoucherType>;
}

export enum EVoucherFilterRestriction {
  CREATED_BY_CURRENT_EMPLOYEE = 'CREATED_BY_CURRENT_EMPLOYEE',
  CURRENT_CUSTOMER = 'CURRENT_CUSTOMER'
}

export interface EVoucherListReportState {
  __typename?: 'EVoucherListReportState';
  creationDate?: Maybe<Scalars['Date']['output']>;
  /** This field contains information if report is generating in current point in time */
  isNewVersionBeingGenerated?: Maybe<Scalars['Boolean']['output']>;
}

export interface EVoucherListReportStateFilterInput {
  type: EVoucherType;
}

export interface EVoucherMarketingConsents {
  __typename?: 'EVoucherMarketingConsents';
  areEventsAndPromotionsRequired?: Maybe<Scalars['Boolean']['output']>;
  isCustomerFeedbackRequired?: Maybe<Scalars['Boolean']['output']>;
  isNewsletterRequired?: Maybe<Scalars['Boolean']['output']>;
  isPhoneRequired?: Maybe<Scalars['Boolean']['output']>;
  isSocialNetworkRequired?: Maybe<Scalars['Boolean']['output']>;
  isTechnicalEducationRequired?: Maybe<Scalars['Boolean']['output']>;
}

export interface EVoucherPaginationResult extends PaginationResult {
  __typename?: 'EVoucherPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<EVoucher>>;
}

export interface EVoucherProductsAdministrationConfiguration {
  __typename?: 'EVoucherProductsAdministrationConfiguration';
  fleetAccountEligibleProducts: Array<EVoucherProductSelection>;
  restrictedProducts: Array<EVoucherProductSelection>;
  standardAccountEligibleProducts: Array<EVoucherProductSelection>;
}

export interface EVoucherProductSelection {
  __typename?: 'EVoucherProductSelection';
  id: Scalars['String']['output'];
  type: EVoucherProductSelectionType;
}

export interface EVoucherProductSelectionInformation {
  __typename?: 'EVoucherProductSelectionInformation';
  numberOfCategories?: Maybe<Scalars['Int']['output']>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  /** The number of selected product types e.g. 'Tool', 'Accessory' */
  numberOfTypes?: Maybe<Scalars['Int']['output']>;
}

export enum EVoucherProductSelectionType {
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT',
  TYPE = 'TYPE'
}

export interface EVoucherProductsSelection {
  __typename?: 'EVoucherProductsSelection';
  excludedProducts: Array<EVoucherProductSelection>;
  includedProducts: Array<EVoucherProductSelection>;
}

export interface EVoucherRedemptionInformation {
  __typename?: 'EVoucherRedemptionInformation';
  date?: Maybe<Scalars['Date']['output']>;
  order?: Maybe<Order>;
  value?: Maybe<Money>;
}

export enum EVoucherReportGenerationStatus {
  ERROR = 'ERROR',
  ERROR_REPORT_IN_PROGRESS = 'ERROR_REPORT_IN_PROGRESS',
  ERROR_TIMEOUT_REQUIRED = 'ERROR_TIMEOUT_REQUIRED',
  SUCCESS = 'SUCCESS'
}

export interface EVoucherRestrictedAccountsConfigurationPaginationResult {
  __typename?: 'EVoucherRestrictedAccountsConfigurationPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Account>;
}

export interface EVoucherRestrictedAccountsFilterInput {
  query?: InputMaybe<Scalars['String']['input']>;
}

export enum EVoucherStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  PROCESSING = 'PROCESSING',
  REDEEMED = 'REDEEMED'
}

export interface EVoucherStoreConfiguration {
  __typename?: 'EVoucherStoreConfiguration';
  isPartialRedemptionEnabled?: Maybe<Scalars['Boolean']['output']>;
  isStandardQuotationEnabled?: Maybe<Scalars['Boolean']['output']>;
}

export enum EVoucherType {
  ACCOUNT = 'ACCOUNT',
  CAMPAIGN = 'CAMPAIGN'
}

export interface ExchangeableBatteriesFilterInput {
  groups?: InputMaybe<Array<InputMaybe<ToolGroup>>>;
}

export enum ExchangeCycle {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY'
}

export interface ExchangeOption {
  __typename?: 'ExchangeOption';
  exchangeCycle?: Maybe<ExchangeCycle>;
  exchangeMonth?: Maybe<Scalars['Int']['output']>;
}

export interface FinalizePaymentInput {
  transactionId: Scalars['String']['input'];
}

export interface FinalizePaymentPayload {
  __typename?: 'FinalizePaymentPayload';
  status?: Maybe<FinalizePaymentStatus>;
}

export enum FinalizePaymentStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface FleetDetails {
  __typename?: 'FleetDetails';
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  contractStartDate?: Maybe<Scalars['Date']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  fleetSubContract?: Maybe<FleetSubContract>;
  inventoryNumber?: Maybe<Scalars['String']['output']>;
  monthlyFee?: Maybe<Money>;
  organizationalReference?: Maybe<Scalars['String']['output']>;
  totalUsagePeriod?: Maybe<Scalars['Int']['output']>;
  usagePeriod?: Maybe<Scalars['Int']['output']>;
}

export enum FleetEContractStatus {
  ACCEPTED = 'ACCEPTED',
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
  HI_SIGNED = 'HI_SIGNED',
  QUOTATION = 'QUOTATION',
  REJECTED = 'REJECTED',
  SIGNED = 'SIGNED',
  STARTED = 'STARTED',
  UPDATED = 'UPDATED'
}

export interface FleetEContractTemplateFilterInput {
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<FleetEContractTemplateNameFilterInput>;
}

export interface FleetEContractTemplateNameFilterInput {
  fleetContractType: Scalars['String']['input'];
  fleetContractVersion: Scalars['String']['input'];
  hasTheftCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  localization: LocalizationInput;
}

export interface FleetInvoiceOptions {
  __typename?: 'FleetInvoiceOptions';
  invoiceGroupedBy?: Maybe<Array<Maybe<InvoiceOption>>>;
  invoiceSplitBy?: Maybe<Array<Maybe<InvoiceOption>>>;
}

export interface FleetLabelingTemplate extends Node {
  __typename?: 'FleetLabelingTemplate';
  id: Scalars['ID']['output'];
  isCustomerLogoVisible?: Maybe<Scalars['Boolean']['output']>;
  isCustomerNameVisible?: Maybe<Scalars['Boolean']['output']>;
  isInventoryNumberVisible?: Maybe<Scalars['Boolean']['output']>;
  isOrganizationalReferenceVisible?: Maybe<Scalars['Boolean']['output']>;
  isSerialNumberVisible?: Maybe<Scalars['Boolean']['output']>;
  orientation?: Maybe<FleetLabelingTemplateOrientation>;
  type?: Maybe<FleetLabelType>;
}

export enum FleetLabelingTemplateOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT'
}

export enum FleetLabelType {
  DIGITAL = 'DIGITAL',
  DIGITAL_PHYSICAL = 'DIGITAL_PHYSICAL',
  PHYSICAL = 'PHYSICAL'
}

export interface FleetMasterContract extends Node {
  __typename?: 'FleetMasterContract';
  customerLogoUri?: Maybe<Scalars['String']['output']>;
  exchangeCycle?: Maybe<ExchangeCycle>;
  exchangeMonth?: Maybe<Scalars['Int']['output']>;
  fleetLabelingTemplate?: Maybe<FleetLabelingTemplate>;
  id: Scalars['ID']['output'];
  invoiceGroupedBy?: Maybe<InvoiceOption>;
  invoiceSplitBy?: Maybe<InvoiceOption>;
  isCostCenterRequired?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentTerms?: Maybe<PaymentTerms>;
  status?: Maybe<FleetMasterContractStatus>;
}

export interface FleetMasterContractFleetLabelingTemplateArgs {
  localization: LocalizationInput;
}

export interface FleetMasterContractOptions {
  __typename?: 'FleetMasterContractOptions';
  availableCostCenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableOrganizationalReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exchangeOptions?: Maybe<Array<Maybe<ExchangeOption>>>;
  fleetLabelingTemplates: Array<Maybe<FleetLabelingTemplate>>;
  fleetLabelType: FleetLabelType;
  invoiceGroupedBy?: Maybe<Array<Maybe<InvoiceOption>>>;
  invoiceSplitBy?: Maybe<Array<Maybe<InvoiceOption>>>;
}

export enum FleetMasterContractStatus {
  ACTIVE = 'ACTIVE',
  BANKRUPTCY = 'BANKRUPTCY',
  INACTIVE = 'INACTIVE',
  PREPARE = 'PREPARE',
  QUOTATION = 'QUOTATION',
  TERMINATED = 'TERMINATED',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS'
}

export interface FleetOrderEntry extends GenericOrderEntry {
  __typename?: 'FleetOrderEntry';
  comboChildren?: Maybe<Array<StandardOrderEntry>>;
  entryNumber: Scalars['Int']['output'];
  fcpTax?: Maybe<Money>;
  fleetDetails?: Maybe<FleetDetails>;
  icmsTax?: Maybe<Money>;
  ipiTax?: Maybe<Money>;
  item?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']['output']>;
}

export interface FleetOrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface FleetOrganizationalReferencesAndCostCenters {
  __typename?: 'FleetOrganizationalReferencesAndCostCenters';
  costCenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organizationalReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface FleetPremiumServices {
  __typename?: 'FleetPremiumServices';
  hasLoanTools?: Maybe<Scalars['Boolean']['output']>;
  hasPeakTools?: Maybe<Scalars['Boolean']['output']>;
  hasTheftCoverage?: Maybe<Scalars['Boolean']['output']>;
}

export interface FleetPrice {
  __typename?: 'FleetPrice';
  monthlyFee: Scalars['BigDecimal']['output'];
  upfrontCost: Scalars['BigDecimal']['output'];
}

export interface FleetPriceDetails {
  __typename?: 'FleetPriceDetails';
  period: Scalars['Int']['output'];
  salesPriceInformation: FleetPrice;
  unitPriceInformation: FleetPrice;
}

export interface FleetQuotation extends GenericOrder, Node, Pageable {
  __typename?: 'FleetQuotation';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  date?: Maybe<Scalars['Date']['output']>;
  delayedBillingInformation?: Maybe<DelayedBillingInformation>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<FleetOrderEntry>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  fleetEContract?: Maybe<EContract>;
  fleetEContractStatus?: Maybe<FleetEContractStatus>;
  fleetSubContract?: Maybe<FleetSubContract>;
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  salesChannel?: Maybe<SalesChannel>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  soldTo?: Maybe<Customer>;
  status?: Maybe<QuotationStatus>;
  totalPrice?: Maybe<Money>;
}

export interface FleetQuotationPaginationResult extends PaginationResult {
  __typename?: 'FleetQuotationPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<FleetQuotation>>;
}

export interface FleetStoreConfiguration {
  __typename?: 'FleetStoreConfiguration';
  delayedBilling?: Maybe<Scalars['Boolean']['output']>;
  inventoryNumberLength?: Maybe<Scalars['Int']['output']>;
  organisationalReferenceLength?: Maybe<Scalars['Int']['output']>;
  quotationEContractingProcess?: Maybe<Scalars['Boolean']['output']>;
}

export interface FleetSubContract extends Node {
  __typename?: 'FleetSubContract';
  /** Id will be quotation until we get the proper information from Cloud */
  id: Scalars['ID']['output'];
  parentContract?: Maybe<FleetMasterContract>;
  premiumServices?: Maybe<FleetPremiumServices>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
}

export interface FormConfiguration extends Node {
  __typename?: 'FormConfiguration';
  fields: Array<FormFieldConfiguration>;
  id: Scalars['ID']['output'];
}

export interface FormFieldConfiguration extends Node {
  __typename?: 'FormFieldConfiguration';
  hiddenOnForm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<FormFieldType>;
  upperCase?: Maybe<Scalars['Boolean']['output']>;
  validation?: Maybe<FormFieldValidation>;
  values?: Maybe<Array<FormFieldValue>>;
}

export interface FormFieldConfigurationValuesArgs {
  localization: LocalizationInput;
}

export enum FormFieldType {
  DROPDOWN = 'DROPDOWN',
  STRING = 'STRING'
}

export interface FormFieldValidation {
  __typename?: 'FormFieldValidation';
  maxLength?: Maybe<Scalars['Int']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
}

export interface FormFieldValue extends Node {
  __typename?: 'FormFieldValue';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export enum FormType {
  ADDRESS = 'ADDRESS',
  ADDRESS_DISPLAY = 'ADDRESS_DISPLAY',
  CONTACT_DISPLAY = 'CONTACT_DISPLAY',
  GUEST_CHECKOUT_BILLING_DETAILS = 'GUEST_CHECKOUT_BILLING_DETAILS',
  GUEST_CHECKOUT_SHIPPING_DETAILS = 'GUEST_CHECKOUT_SHIPPING_DETAILS',
  NEW_CONTACT = 'NEW_CONTACT',
  PROFILE_COMPANY = 'PROFILE_COMPANY',
  PROFILE_CONTACT = 'PROFILE_CONTACT'
}

export interface FreeTextSearchResultsCount {
  __typename?: 'FreeTextSearchResultsCount';
  documents: Scalars['Int']['output'];
  editorials: Scalars['Int']['output'];
  firestop: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
  softwareFaqs: Scalars['Int']['output'];
  videos: Scalars['Int']['output'];
}

export interface FreeTextSearchResultsCountFilterInput {
  includeSpecialProducts?: InputMaybe<Scalars['Boolean']['input']>;
  localization: LocalizationInput;
  query: Scalars['String']['input'];
}

export interface GenerateCircularityReportInput {
  localization: LocalizationInput;
  year: Scalars['Int']['input'];
}

export interface GenerateCircularityReportPayload {
  __typename?: 'GenerateCircularityReportPayload';
  url: Scalars['String']['output'];
}

export interface GenerateEVoucherCampaignReportPayload {
  __typename?: 'GenerateEVoucherCampaignReportPayload';
  eVoucherId: Scalars['ID']['output'];
}

export interface GenerateEVoucherListReportInput {
  type: EVoucherType;
}

export interface GenerateEVoucherListReportPayload {
  __typename?: 'GenerateEVoucherListReportPayload';
  status?: Maybe<EVoucherReportGenerationStatus>;
}

export interface GenerateQuotationConfirmationDocumentInput {
  quotationId: Scalars['ID']['input'];
}

export interface GenerateQuotationConfirmationDocumentPayload {
  __typename?: 'GenerateQuotationConfirmationDocumentPayload';
  quotationId: Scalars['ID']['output'];
}

export interface GenerateRapidPayAccessTokenPayload {
  __typename?: 'GenerateRapidPayAccessTokenPayload';
  accessToken: Scalars['JWT']['output'];
}

export interface GenerateShippingAddressOneTimePasswordPayload {
  __typename?: 'GenerateShippingAddressOneTimePasswordPayload';
  status: GenerateShippingAddressOneTimePasswordStatus;
}

export enum GenerateShippingAddressOneTimePasswordStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface GenerateSubscriptionAmendmentEContractIframeUrlInput {
  returnUri: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
}

/** A GenericOrder is a base line for orders and quotations */
export interface GenericOrder {
  billToAccount?: Maybe<Account>;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<GenericOrderEntry>;
  id: Scalars['ID']['output'];
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  soldTo?: Maybe<Customer>;
  totalPrice?: Maybe<Money>;
}

export interface GenericOrderEntry {
  entryNumber: Scalars['Int']['output'];
  item?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']['output']>;
}

export interface GenericOrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface GeoLocation {
  __typename?: 'GeoLocation';
  accuracy?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
}

export interface HiltiCenter {
  __typename?: 'HiltiCenter';
  address?: Maybe<Address>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<GeoLocation>;
  name?: Maybe<Scalars['String']['output']>;
  openingSchedule?: Maybe<WeeklyOpeningSchedule>;
  originId?: Maybe<Scalars['String']['output']>;
  /** slug is expected to be URL encoded (e.g. it will be "osnabr%C3%BCck" instead of "osnabrück") */
  slug?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use slug instead */
  uri?: Maybe<Scalars['String']['output']>;
}

export interface InitiatePaymentBillingAddressInput {
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
}

export interface InitiatePaymentCustomerInput {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}

export interface InitiatePaymentInput {
  billingAddress?: InputMaybe<InitiatePaymentBillingAddressInput>;
  customer: InitiatePaymentCustomerInput;
  transactionValue: MoneyInput;
}

export interface InitiatePaymentPayload {
  __typename?: 'InitiatePaymentPayload';
  libraryUrl: Scalars['URL']['output'];
  paymentPageConfigurationId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
}

export interface InProgressCompanyAccountRegistrationInput {
  address?: InputMaybe<RegisterAddressInput>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
}

export interface InProgressContactRegistrationInput {
  academicTitle?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export enum InvoiceOption {
  BLANK = 'BLANK',
  COST_CENTER = 'COST_CENTER',
  ORGANIZATIONAL_REFERENCE = 'ORGANIZATIONAL_REFERENCE',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER',
  SHIP_TO = 'SHIP_TO'
}

export interface InvoiceStatus extends Localizable {
  __typename?: 'InvoiceStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface InvoiceStatusNameArgs {
  localization: LocalizationInput;
}

export enum ItemCategoryGroup {
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export interface ItemPriceInformation {
  __typename?: 'ItemPriceInformation';
  priceQuantity?: Maybe<Scalars['Float']['output']>;
  priceUnit?: Maybe<SalesUnit>;
  totalPrice?: Maybe<Money>;
  unitPrice?: Maybe<Money>;
}

export interface LicenseUserAssignment extends Node {
  __typename?: 'LicenseUserAssignment';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subscriptionStatus: SoftwareSubscriptionAssignmentStatus;
}

export interface Link {
  __typename?: 'Link';
  label?: Maybe<Scalars['String']['output']>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
}

export interface Localizable {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface LocalizableNameArgs {
  localization: LocalizationInput;
}

export interface LocalizationInput {
  country: Scalars['String']['input'];
  language: Scalars['String']['input'];
}

export interface LocalizedValueFilterInput {
  ids: Array<Scalars['String']['input']>;
}

export interface MakeItFitProduct {
  __typename?: 'MakeItFitProduct';
  /** Explains the reason behind the recommendation */
  compatibilityRecommendationReason?: Maybe<Scalars['String']['output']>;
  /** The compatible chargers for the battery */
  compatibleChargerIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Determines if a case is included with the tool */
  isCaseIncluded?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this product is a Hilti recommended one */
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  /** The product details including the thumbnail 300x300 will be resolved from makeitfit service */
  product?: Maybe<Product>;
}

export interface MakeItFitToolsWithDefaultPackage {
  __typename?: 'MakeItFitToolsWithDefaultPackage';
  /** Default battery for the package */
  defaultBattery?: Maybe<MakeItFitProduct>;
  /** Default charger for the package */
  defaultCharger?: Maybe<MakeItFitProduct>;
  /** Available tools */
  tools?: Maybe<Array<MakeItFitProduct>>;
}

export interface MarketingBannerFilterInput {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  journeyId: Scalars['UUID']['input'];
  /** CMS page template name, HomePage, etc */
  pageType?: InputMaybe<Scalars['String']['input']>;
  permanentlyBannedBannerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Current page uri */
  uri: Scalars['String']['input'];
}

export interface MarketingConsent {
  __typename?: 'MarketingConsent';
  consentValue?: Maybe<Scalars['Boolean']['output']>;
  type: MarketingConsentType;
}

export interface MarketingConsentInput {
  consentValue: Scalars['Boolean']['input'];
  type: MarketingConsentType;
}

export enum MarketingConsentSource {
  HILTI_ONLINE_MY_ACCOUNT = 'HILTI_ONLINE_MY_ACCOUNT',
  HILTI_ONLINE_QUICK_CHECKOUT = 'HILTI_ONLINE_QUICK_CHECKOUT',
  HILTI_ONLINE_REGISTRATION = 'HILTI_ONLINE_REGISTRATION'
}

export enum MarketingConsentType {
  CUSTOMER_FEEDBACK = 'CUSTOMER_FEEDBACK',
  EVENTS_AND_PROMOTIONS = 'EVENTS_AND_PROMOTIONS',
  NEWSLETTER = 'NEWSLETTER',
  PHONE = 'PHONE',
  SOCIAL_NETWORK = 'SOCIAL_NETWORK',
  TECHNICAL_EDUCATION = 'TECHNICAL_EDUCATION'
}

export enum MarketingConsentUpdateStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface MaxDiscountDeterminationRule {
  __typename?: 'MaxDiscountDeterminationRule';
  checkoutPossible?: Maybe<Scalars['Boolean']['output']>;
  entryLevelWarnings?: Maybe<Scalars['Boolean']['output']>;
  headerPolicyExceeded?: Maybe<Scalars['Boolean']['output']>;
  itemPolicyExceeded?: Maybe<Scalars['Boolean']['output']>;
  warningLevel?: Maybe<Scalars['String']['output']>;
}

export interface MigrateLegacySoftwareSubscriptionInput {
  subscriptionId: Scalars['ID']['input'];
}

export interface MigrateLegacySoftwareSubscriptionPayload {
  __typename?: 'MigrateLegacySoftwareSubscriptionPayload';
  subscriptionId: Scalars['ID']['output'];
}

export interface MiniTeaserBanner extends Node {
  __typename?: 'MiniTeaserBanner';
  body?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  linkUri?: Maybe<Scalars['String']['output']>;
  webAnalyticsData?: Maybe<WebAnalyticsData>;
}

export interface Money {
  __typename?: 'Money';
  amount?: Maybe<Scalars['BigDecimal']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
}

export interface MoneyInput {
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['String']['input'];
}

export enum Month {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptSoftwareSubscriptionMasterAgreementAmendment?: Maybe<AcceptSoftwareSubscriptionMasterAgreementAmendmentPayload>;
  activateCampaignEVoucher?: Maybe<ActivateCampaignEVoucherPayload>;
  activateSoftwareSubscription?: Maybe<ActivateSoftwareSubscriptionPayload>;
  /** This mutation is used for adding different products to cart. If cartId is omitted, a new cart will be created automatically */
  addToCart?: Maybe<AddToCartPayload>;
  addToShoppingList?: Maybe<AddToShoppingListPayload>;
  applyOrderDraftEVoucher: ApplyOrderDraftEVoucherPayload;
  approveFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  approveQuotationForRepairNotifications?: Maybe<RepairQuotationDecisionPayload>;
  assignSoftwareSubscriptionContact?: Maybe<AssignSoftwareSubscriptionContactPayload>;
  assignSoftwareSubscriptionContacts?: Maybe<AssignSoftwareSubscriptionContactsPayload>;
  calculateSoftwareSubscriptionPrice?: Maybe<CalculateSoftwareSubscriptionPricePayload>;
  callMeBack?: Maybe<CallMeBackPayload>;
  cancelPurchaseRequest: UpdatePurchaseRequestPayload;
  cancelSoftwareSubscription?: Maybe<CancelSoftwareSubscriptionPayload>;
  changeToolsCostCenter?: Maybe<ToolsProcessPayload>;
  changeToolsLabels?: Maybe<ToolsProcessPayload>;
  checkAddress?: Maybe<CheckAddressPayload>;
  copyCompanyToPrivateShoppingList?: Maybe<CopyCompanyToPrivateShoppingPayload>;
  copyPrivateToCompanyShoppingList?: Maybe<CopyPrivateToCompanyShoppingPayload>;
  createAccountEVoucher?: Maybe<CreateAccountEVoucherPayload>;
  createCampaignEVoucher?: Maybe<CreateCampaignEVoucherPayload>;
  /** This mutation is used for creating a new cart for anonymous user or try to restore existing cart for logged in user */
  createCart?: Maybe<CreateCartPayload>;
  createCompanyShoppingList?: Maybe<CreateShoppingListPayload>;
  createContact?: Maybe<CreateContactPayload>;
  createCustomerCareNote?: Maybe<CustomerCareNotePayload>;
  createFleetEContract?: Maybe<EContractPayload>;
  createLegacySoftwareSubscriptionMasterAgreement?: Maybe<CreateLegacySoftwareSubscriptionMasterAgreementPayload>;
  createOrderDraftFromQuotation?: Maybe<CreateOrderDraftFromQuotationPayload>;
  createPrivateShoppingList?: Maybe<CreateShoppingListPayload>;
  createShippingAddress?: Maybe<CreateShippingAddressPayload>;
  createSoftwareSubscriptionMasterAgreementAmendment?: Maybe<CreateSoftwareSubscriptionMasterAgreementAmendmentPayload>;
  deactivateEVoucher?: Maybe<DeactivateEVoucherPayload>;
  declineSoftwareSubscriptionMasterAgreementAmendment?: Maybe<DeclineSoftwareSubscriptionMasterAgreementAmendmentPayload>;
  deleteOrderDraftPurchaseOrderDocument?: Maybe<DeleteOrderDraftPurchaseOrderDocumentPayload>;
  deletePurchaseRequest: UpdatePurchaseRequestPayload;
  deleteShoppingList?: Maybe<DeleteShoppingListPayload>;
  deleteSoftwareSubscription?: Maybe<DeleteSoftwareSubscriptionPayload>;
  finalizePayment?: Maybe<FinalizePaymentPayload>;
  generateCircularityReport?: Maybe<GenerateCircularityReportPayload>;
  generateEContractIframeUrl?: Maybe<EContractPayload>;
  generateEVoucherCampaignReport?: Maybe<GenerateEVoucherCampaignReportPayload>;
  generateEVoucherListReport?: Maybe<GenerateEVoucherListReportPayload>;
  generateQuotationConfirmationDocument?: Maybe<GenerateQuotationConfirmationDocumentPayload>;
  /** RapidPay specific as rework is likely soon */
  generateRapidPayAccessToken?: Maybe<GenerateRapidPayAccessTokenPayload>;
  generateShippingAddressOneTimePassword?: Maybe<GenerateShippingAddressOneTimePasswordPayload>;
  generateSubscriptionActivationEContractIframeUrl?: Maybe<EContractPayload>;
  generateSubscriptionAmendmentEContractIframeUrl?: Maybe<EContractPayload>;
  initiatePayment?: Maybe<InitiatePaymentPayload>;
  markContactAsFleetExchangeResponsible?: Maybe<UpdateContactPayload>;
  markContactAsFleetResponsible?: Maybe<UpdateContactPayload>;
  markFleetQuotationForEContracting?: Maybe<UpdateFleetQuotationPayload>;
  migrateLegacySoftwareSubscription?: Maybe<MigrateLegacySoftwareSubscriptionPayload>;
  orderBatteriesExchange?: Maybe<OrderBatteriesExchangePayload>;
  /** This mutation is used for quickly adding different products to cart with default purchase type. If cartId is omitted, a new cart will be created automatically */
  quickAddToCart?: Maybe<AddToCartPayload>;
  reactivateEVoucher?: Maybe<ReactivateEVoucherPayload>;
  reassignSoftwareSubscriptionContact?: Maybe<ReassignSoftwareSubscriptionContactPayload>;
  reassignSoftwareSubscriptionContacts?: Maybe<ReassignSoftwareSubscriptionContactsPayload>;
  recycleBatteries?: Maybe<RecycleBatteriesDecisionPayload>;
  recycleToolsForRepairNotifications?: Maybe<RepairQuotationDecisionPayload>;
  registerCustomer?: Maybe<RegisterCustomerPayload>;
  rejectFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  rejectPurchaseRequest: UpdatePurchaseRequestPayload;
  releaseOrderDraftEVoucher: ReleaseOrderDraftEVoucherPayload;
  removeAllAccountsFromCampaignEVoucher?: Maybe<RemoveAllAccountsFromCampaignEVoucherPayload>;
  removeAllSoftwareSubscriptionScheduledAmendments?: Maybe<RemoveAllSoftwareSubscriptionScheduledAmendmentsPayload>;
  removeCart?: Maybe<RemoveCartPayload>;
  removeItemsFromShoppingList?: Maybe<RemoveItemsFromShoppingListPayload>;
  reorderToolsLabels?: Maybe<ToolsProcessPayload>;
  reportLostTools?: Maybe<ToolsProcessPayload>;
  reportStolenTools?: Maybe<ToolsProcessPayload>;
  reprintOrderDeliveryNotes?: Maybe<ReprintOrderDeliveryNotesPayload>;
  resendFleetQuotationConfirmation?: Maybe<ResendFleetQuotationConfirmationPayload>;
  resendOrderConfirmation?: Maybe<ResendOrderConfirmationPayload>;
  resendQuotationConfirmation?: Maybe<ResendQuotationConfirmationPayload>;
  returnTools?: Maybe<ToolsProcessPayload>;
  /** Saves a customer journey by appending the URL to an existing journey or creates a new one in case journeyId is not provided/it expired. */
  saveCustomerJourney?: Maybe<SaveCustomerJourneyPayload>;
  sendMessageToCustomerService?: Maybe<SendMessageToCustomerServicePayload>;
  signFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  softwareSubscriptionChangePaymentMethodToInvoice?: Maybe<SoftwareSubscriptionChangePaymentMethodToInvoicePayload>;
  submitGuestOrder?: Maybe<SubmitGuestOrderPayload>;
  submitOrder?: Maybe<SubmitOrderPayload>;
  temporarilyBanBanner?: Maybe<TemporarilyBanBannerPayload>;
  tradeInAndRecycleToolsForRepairNotifications?: Maybe<RepairQuotationDecisionPayload>;
  transferSoftwareSubscriptionAdminRights?: Maybe<TransferSoftwareSubscriptionAdminRightsPayload>;
  unassignSoftwareSubscriptionContact?: Maybe<UnassignSoftwareSubscriptionContactPayload>;
  unassignSoftwareSubscriptionContacts?: Maybe<UnassignSoftwareSubscriptionContactsPayload>;
  updateCampaignEVoucher?: Maybe<UpdateCampaignEVoucherPayload>;
  updateFleetEContract?: Maybe<EContractPayload>;
  updateFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  updateMarketingConsents?: Maybe<UpdateMarketingConsentsPayload>;
  updateOrderDraftBillToAccount?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftDeliveryMethod?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftEntryPaymentMethod?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftPurchaseOrderNumber?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftShipToAccount?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftShipToContact?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftShipToHiltiCenter?: Maybe<UpdateOrderDraftPayload>;
  updateRepairNotificationShippingDetails?: Maybe<UpdateRepairNotificationPayload>;
  updateShoppingList?: Maybe<UpdateShoppingListPayload>;
  updateShoppingListItemPurchaseType?: Maybe<UpdateShoppingListItemPayload>;
  updateShoppingListItemQuantity?: Maybe<UpdateShoppingListItemPayload>;
  updateShoppingListItemsPosition?: Maybe<UpdateShoppingListItemsPayload>;
  updateSoftwareSubscriptionPurchaseOrderNumber?: Maybe<UpdateSoftwareSubscriptionPurchaseOrderNumberPayload>;
  /** RapidPay specific as rework is likely soon */
  updateSoftwareSubscriptionRapidPayCreditCardDetails?: Maybe<UpdateSoftwareSubscriptionRapidPayCreditCardDetailsPayload>;
  validatePurchaseOrderNumber?: Maybe<ValidatePurchaseOrderNumberPayload>;
  /** RapidPay specific as rework is likely soon */
  verifyRapidPayCreditCardAuthentication?: Maybe<VerifyRapidPayCreditCardAuthenticationPayload>;
}

export interface MutationAcceptSoftwareSubscriptionMasterAgreementAmendmentArgs {
  input: AcceptSoftwareSubscriptionMasterAgreementAmendmentInput;
}

export interface MutationActivateCampaignEVoucherArgs {
  id: Scalars['ID']['input'];
}

export interface MutationActivateSoftwareSubscriptionArgs {
  input: ActivateSoftwareSubscriptionInput;
}

export interface MutationAddToCartArgs {
  input: AddToCartInput;
}

export interface MutationAddToShoppingListArgs {
  input: AddToShoppingListInput;
}

export interface MutationApplyOrderDraftEVoucherArgs {
  input: ApplyOrderDraftEVoucherInput;
}

export interface MutationApproveFleetQuotationArgs {
  input: ApproveFleetQuotationInput;
}

export interface MutationApproveQuotationForRepairNotificationsArgs {
  input: ApproveQuotationForRepairNotifications;
}

export interface MutationAssignSoftwareSubscriptionContactArgs {
  input: AssignSoftwareSubscriptionContactInput;
}

export interface MutationAssignSoftwareSubscriptionContactsArgs {
  input: AssignSoftwareSubscriptionContactsInput;
}

export interface MutationCalculateSoftwareSubscriptionPriceArgs {
  input: CalculateSoftwareSubscriptionPriceInput;
}

export interface MutationCallMeBackArgs {
  input: CallMeBackInput;
}

export interface MutationCancelPurchaseRequestArgs {
  id: Scalars['ID']['input'];
}

export interface MutationCancelSoftwareSubscriptionArgs {
  input: CancelSoftwareSubscriptionInput;
}

export interface MutationChangeToolsCostCenterArgs {
  input: ChangeToolsCostCenterInput;
}

export interface MutationChangeToolsLabelsArgs {
  input: ChangeToolsLabelsInput;
}

export interface MutationCheckAddressArgs {
  input: CheckAddressInput;
}

export interface MutationCopyCompanyToPrivateShoppingListArgs {
  input: CopyCompanyToPrivateShoppingListInput;
}

export interface MutationCopyPrivateToCompanyShoppingListArgs {
  input: CopyPrivateToCompanyShoppingListInput;
}

export interface MutationCreateAccountEVoucherArgs {
  input: CreateAccountEVoucherInput;
}

export interface MutationCreateCampaignEVoucherArgs {
  input: CreateCampaignEVoucherInput;
}

export interface MutationCreateCartArgs {
  input: CreateCartInput;
}

export interface MutationCreateCompanyShoppingListArgs {
  input: CreateCompanyShoppingListInput;
}

export interface MutationCreateContactArgs {
  input: CreateContactInput;
}

export interface MutationCreateCustomerCareNoteArgs {
  input: CreateCustomerCareNoteInput;
}

export interface MutationCreateFleetEContractArgs {
  input: CreateEContractInput;
}

export interface MutationCreateLegacySoftwareSubscriptionMasterAgreementArgs {
  input: CreateLegacySoftwareSubscriptionMasterAgreementInput;
}

export interface MutationCreateOrderDraftFromQuotationArgs {
  input: CreateOrderDraftFromQuotationInput;
}

export interface MutationCreatePrivateShoppingListArgs {
  input: CreatePrivateShoppingListInput;
}

export interface MutationCreateShippingAddressArgs {
  input: CreateShippingAddressInput;
}

export interface MutationCreateSoftwareSubscriptionMasterAgreementAmendmentArgs {
  input: CreateSoftwareSubscriptionMasterAgreementAmendmentInput;
}

export interface MutationDeactivateEVoucherArgs {
  id: Scalars['ID']['input'];
}

export interface MutationDeclineSoftwareSubscriptionMasterAgreementAmendmentArgs {
  input: DeclineSoftwareSubscriptionMasterAgreementAmendmentInput;
}

export interface MutationDeleteOrderDraftPurchaseOrderDocumentArgs {
  input: DeleteOrderDraftPurchaseOrderDocumentInput;
}

export interface MutationDeletePurchaseRequestArgs {
  id: Scalars['ID']['input'];
}

export interface MutationDeleteShoppingListArgs {
  id: Scalars['ID']['input'];
}

export interface MutationDeleteSoftwareSubscriptionArgs {
  input: DeleteSoftwareSubscriptionInput;
}

export interface MutationFinalizePaymentArgs {
  input: FinalizePaymentInput;
}

export interface MutationGenerateCircularityReportArgs {
  input: GenerateCircularityReportInput;
}

export interface MutationGenerateEContractIframeUrlArgs {
  input: EContractIframeUrlInput;
}

export interface MutationGenerateEVoucherCampaignReportArgs {
  id: Scalars['ID']['input'];
}

export interface MutationGenerateEVoucherListReportArgs {
  input: GenerateEVoucherListReportInput;
}

export interface MutationGenerateQuotationConfirmationDocumentArgs {
  input: GenerateQuotationConfirmationDocumentInput;
}

export interface MutationGenerateRapidPayAccessTokenArgs {
  localization?: InputMaybe<LocalizationInput>;
}

export interface MutationGenerateSubscriptionActivationEContractIframeUrlArgs {
  input: SubscriptionActivationEContractIframeUrlInput;
}

export interface MutationGenerateSubscriptionAmendmentEContractIframeUrlArgs {
  input: GenerateSubscriptionAmendmentEContractIframeUrlInput;
}

export interface MutationInitiatePaymentArgs {
  input: InitiatePaymentInput;
}

export interface MutationMarkContactAsFleetExchangeResponsibleArgs {
  id: Scalars['ID']['input'];
}

export interface MutationMarkContactAsFleetResponsibleArgs {
  id: Scalars['ID']['input'];
}

export interface MutationMarkFleetQuotationForEContractingArgs {
  quotationId: Scalars['ID']['input'];
}

export interface MutationMigrateLegacySoftwareSubscriptionArgs {
  input: MigrateLegacySoftwareSubscriptionInput;
}

export interface MutationOrderBatteriesExchangeArgs {
  input: OrderBatteriesExchangeInput;
}

export interface MutationQuickAddToCartArgs {
  input: QuickAddToCartInput;
}

export interface MutationReactivateEVoucherArgs {
  input: ReactivateEVoucherInput;
}

export interface MutationReassignSoftwareSubscriptionContactArgs {
  input: ReassignSoftwareSubscriptionContactInput;
}

export interface MutationReassignSoftwareSubscriptionContactsArgs {
  input: ReassignSoftwareSubscriptionContactsInput;
}

export interface MutationRecycleBatteriesArgs {
  input: RecycleBatteriesInput;
}

export interface MutationRecycleToolsForRepairNotificationsArgs {
  input: RecycleToolsForRepairNotificationsInput;
}

export interface MutationRegisterCustomerArgs {
  input: RegisterCustomerInput;
}

export interface MutationRejectFleetQuotationArgs {
  input: RejectFleetQuotationInput;
}

export interface MutationRejectPurchaseRequestArgs {
  input: RejectPurchaseRequestInput;
}

export interface MutationReleaseOrderDraftEVoucherArgs {
  input: ReleaseOrderDraftEVoucherInput;
}

export interface MutationRemoveAllAccountsFromCampaignEVoucherArgs {
  id: Scalars['ID']['input'];
}

export interface MutationRemoveAllSoftwareSubscriptionScheduledAmendmentsArgs {
  input: RemoveAllSoftwareSubscriptionScheduledAmendmentsInput;
}

export interface MutationRemoveCartArgs {
  input: RemoveCartInput;
}

export interface MutationRemoveItemsFromShoppingListArgs {
  input: RemoveItemsFromShoppingListInput;
}

export interface MutationReorderToolsLabelsArgs {
  input: ReorderToolsLabelsInput;
}

export interface MutationReportLostToolsArgs {
  input: ReportLostToolsInput;
}

export interface MutationReportStolenToolsArgs {
  input: ReportStolenToolsInput;
}

export interface MutationReprintOrderDeliveryNotesArgs {
  input: ReprintOrderDeliveryNotesInput;
}

export interface MutationResendFleetQuotationConfirmationArgs {
  input: ResendFleetQuotationConfirmationInput;
}

export interface MutationResendOrderConfirmationArgs {
  input: ResendOrderConfirmationInput;
}

export interface MutationResendQuotationConfirmationArgs {
  input: ResendQuotationConfirmationInput;
}

export interface MutationReturnToolsArgs {
  input: ReturnToolsInput;
}

export interface MutationSaveCustomerJourneyArgs {
  input: SaveCustomerJourneyInput;
}

export interface MutationSendMessageToCustomerServiceArgs {
  input: SendMessageToCustomerServiceInput;
}

export interface MutationSignFleetQuotationArgs {
  input: SignFleetQuotationInput;
}

export interface MutationSoftwareSubscriptionChangePaymentMethodToInvoiceArgs {
  input: SoftwareSubscriptionChangePaymentMethodToInvoiceInput;
}

export interface MutationSubmitGuestOrderArgs {
  input: SubmitGuestOrderInput;
}

export interface MutationSubmitOrderArgs {
  input: SubmitOrderInput;
}

export interface MutationTemporarilyBanBannerArgs {
  input: TemporarilyBanBannerInput;
  localization: LocalizationInput;
}

export interface MutationTradeInAndRecycleToolsForRepairNotificationsArgs {
  input: TradeInAndRecycleToolsForRepairNotificationsInput;
}

export interface MutationTransferSoftwareSubscriptionAdminRightsArgs {
  input: TransferSoftwareSubscriptionAdminRightsInput;
}

export interface MutationUnassignSoftwareSubscriptionContactArgs {
  input: UnassignSoftwareSubscriptionContactInput;
}

export interface MutationUnassignSoftwareSubscriptionContactsArgs {
  input: UnassignSoftwareSubscriptionContactsInput;
}

export interface MutationUpdateCampaignEVoucherArgs {
  input: UpdateCampaignEVoucherInput;
}

export interface MutationUpdateFleetEContractArgs {
  input: UpdateEContractInput;
}

export interface MutationUpdateFleetQuotationArgs {
  input: UpdateFleetQuotationInput;
}

export interface MutationUpdateMarketingConsentsArgs {
  input: UpdateMarketingConsentsInput;
}

export interface MutationUpdateOrderDraftBillToAccountArgs {
  input: UpdateOrderDraftBillToAccountInput;
}

export interface MutationUpdateOrderDraftDeliveryMethodArgs {
  input: UpdateOrderDraftDeliveryMethodInput;
}

export interface MutationUpdateOrderDraftEntryPaymentMethodArgs {
  input: UpdateOrderDraftEntryPaymentMethodInput;
}

export interface MutationUpdateOrderDraftPurchaseOrderNumberArgs {
  input: UpdateOrderDraftPurchaseOrderNumberInput;
}

export interface MutationUpdateOrderDraftShipToAccountArgs {
  input: UpdateOrderDraftShipToAccountInput;
}

export interface MutationUpdateOrderDraftShipToContactArgs {
  input: UpdateOrderDraftShipToContactInput;
}

export interface MutationUpdateOrderDraftShipToHiltiCenterArgs {
  input: UpdateOrderDraftShipToHiltiCenterInput;
}

export interface MutationUpdateRepairNotificationShippingDetailsArgs {
  input: UpdateRepairNotificationShippingDetailsInput;
  localization: LocalizationInput;
}

export interface MutationUpdateShoppingListArgs {
  input: UpdateShoppingListInput;
}

export interface MutationUpdateShoppingListItemPurchaseTypeArgs {
  input: UpdateShoppingListItemPurchaseTypeInput;
}

export interface MutationUpdateShoppingListItemQuantityArgs {
  input: UpdateShoppingListItemQuantityInput;
}

export interface MutationUpdateShoppingListItemsPositionArgs {
  input: UpdateShoppingListItemsPositionInput;
}

export interface MutationUpdateSoftwareSubscriptionPurchaseOrderNumberArgs {
  input: UpdateSoftwareSubscriptionPurchaseOrderNumberInput;
}

export interface MutationUpdateSoftwareSubscriptionRapidPayCreditCardDetailsArgs {
  input: UpdateSoftwareSubscriptionRapidPayCreditCardDetailsInput;
}

export interface MutationValidatePurchaseOrderNumberArgs {
  input: ValidatePurchaseOrderNumberInput;
}

export interface MutationVerifyRapidPayCreditCardAuthenticationArgs {
  input: VerifyRapidPayCreditCardAuthenticationInput;
  localization?: InputMaybe<LocalizationInput>;
}

/** An object with a Globally Unique ID */
export interface Node {
  id: Scalars['ID']['output'];
}

export interface NonTargetedCampaignEVoucherDetails {
  __typename?: 'NonTargetedCampaignEVoucherDetails';
  eligibleMarketingConsents?: Maybe<EVoucherMarketingConsents>;
  maxNumberOfEmployees?: Maybe<Scalars['Int']['output']>;
  minNumberOfEmployees?: Maybe<Scalars['Int']['output']>;
  registeredAfter?: Maybe<Scalars['Date']['output']>;
  registeredBefore?: Maybe<Scalars['Date']['output']>;
}

export interface NonTargetedRedemptionRulesInput {
  areEventsAndPromotionsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomerFeedbackRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isNewsletterRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isSocialNetworkRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTechnicalEducationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxNumberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  registeredAfter?: InputMaybe<Scalars['Date']['input']>;
  registeredBefore?: InputMaybe<Scalars['Date']['input']>;
}

export interface Order extends GenericOrder, Node, Pageable {
  __typename?: 'Order';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  clickAndCollectHiltiCenter?: Maybe<HiltiCenter>;
  /** Additional reference number. For example littra number for MO SE */
  customerAdditionalReferenceNumber?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryCompletionStatus?: Maybe<CompletionStatus>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<GenericOrderEntry>;
  eVoucherValue?: Maybe<Money>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  id: Scalars['ID']['output'];
  ipiTax?: Maybe<Money>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** This field is not mapped */
  payerAccount?: Maybe<Account>;
  paymentMethod?: Maybe<PaymentMethod>;
  preparationStatus?: Maybe<CompletionStatus>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  rejectionStatus?: Maybe<OrderRejectionStatus>;
  repairNotification?: Maybe<RepairNotification>;
  /** @deprecated Use repairNotification.id */
  repairOrderNotificationId?: Maybe<Scalars['String']['output']>;
  salesChannel?: Maybe<SalesChannel>;
  shipments?: Maybe<Array<ShipmentInformation>>;
  shipmentStatus?: Maybe<CompletionStatus>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  /** This field is not mapped */
  soldTo?: Maybe<Customer>;
  status?: Maybe<OrderStatus>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalDiscount?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<OrderType>;
}

export interface OrderBatteriesExchangeInput {
  billToAccountOriginId: Scalars['String']['input'];
  carrierInstructions?: InputMaybe<Scalars['String']['input']>;
  lock?: InputMaybe<BatteriesExchangeLockType>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipToAccountOriginId: Scalars['String']['input'];
  shipToContactOriginId: Scalars['String']['input'];
  toolIds: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface OrderBatteriesExchangePayload {
  __typename?: 'OrderBatteriesExchangePayload';
  toolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface OrderDetails extends GenericOrder, Node, Pageable {
  __typename?: 'OrderDetails';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  clickAndCollectHiltiCenter?: Maybe<HiltiCenter>;
  /** Additional reference number. For example littra number for MO SE */
  customerAdditionalReferenceNumber?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryCompletionStatus?: Maybe<CompletionStatus>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<GenericOrderEntry>;
  eVoucherValue?: Maybe<Money>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  id: Scalars['ID']['output'];
  ipiTax?: Maybe<Money>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** This field is not mapped */
  payerAccount?: Maybe<Account>;
  paymentMethod?: Maybe<PaymentMethod>;
  preparationStatus?: Maybe<CompletionStatus>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  rejectionStatus?: Maybe<OrderRejectionStatus>;
  repairNotification?: Maybe<RepairNotification>;
  /** @deprecated Use repairNotification.id */
  repairOrderNotificationId?: Maybe<Scalars['String']['output']>;
  salesChannel?: Maybe<SalesChannel>;
  shipments?: Maybe<Array<ShipmentInformation>>;
  shipmentStatus?: Maybe<CompletionStatus>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  /** This field is not mapped */
  soldTo?: Maybe<Customer>;
  status?: Maybe<OrderStatus>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalDiscount?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<OrderType>;
}

export interface OrderDraft extends Node {
  __typename?: 'OrderDraft';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  carrierInstructions?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<DeliveryType>;
  eVoucherCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  purchaseOrderDocument?: Maybe<PurchaseOrderDocument>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quotationId?: Maybe<Scalars['String']['output']>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  simulationStatus?: Maybe<OrderDraftSimulationStatus>;
  standardDetails?: Maybe<OrderDraftStandardDetails>;
  subscriptionDetails?: Maybe<OrderDraftSubscriptionDetails>;
  totalWeight?: Maybe<Dimension>;
}

export interface OrderDraftEntryExpectedShipment {
  __typename?: 'OrderDraftEntryExpectedShipment';
  quantity: Scalars['Float']['output'];
  shipmentScheduleInformation: ShipmentScheduleInformation;
}

export enum OrderDraftEntryType {
  FLEET = 'FLEET',
  PEAK = 'PEAK',
  SOFTWARE = 'SOFTWARE',
  STANDARD = 'STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export enum OrderDraftSimulationStatus {
  CALCULATED = 'CALCULATED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_SIMULATED = 'NOT_SIMULATED',
  SIMULATED = 'SIMULATED',
  SKIPPED = 'SKIPPED'
}

export interface OrderDraftStandardDetails {
  __typename?: 'OrderDraftStandardDetails';
  deliveryMethod?: Maybe<DeliveryMethod>;
  entries: Array<OrderDraftStandardEntry>;
  paymentMethod?: Maybe<PaymentMethod>;
  priceInformation?: Maybe<PriceInformation>;
  requestedDeliveryDate?: Maybe<Scalars['Date']['output']>;
}

export interface OrderDraftStandardEntry {
  __typename?: 'OrderDraftStandardEntry';
  expectedShipments?: Maybe<Array<OrderDraftEntryExpectedShipment>>;
  item: Product;
  priceInformation: EntryPriceInformation;
  quantity: Scalars['Float']['output'];
}

export interface OrderDraftStandardEntryItemArgs {
  localization: LocalizationInput;
}

export interface OrderDraftSubscriptionDetails {
  __typename?: 'OrderDraftSubscriptionDetails';
  entries: Array<OrderDraftSubscriptionEntry>;
  paymentMethod?: Maybe<PaymentMethod>;
  priceInformation?: Maybe<PriceInformation>;
}

export interface OrderDraftSubscriptionEntry {
  __typename?: 'OrderDraftSubscriptionEntry';
  billingType: BillingCycle;
  item: Product;
  priceInformation: EntryPriceInformation;
  quantity: Scalars['Float']['output'];
}

export interface OrderDraftSubscriptionEntryItemArgs {
  localization: LocalizationInput;
}

export interface OrderEntry extends GenericOrderEntry {
  __typename?: 'OrderEntry';
  comboChildren?: Maybe<Array<GenericOrderEntry>>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  discount?: Maybe<Discount>;
  entryNumber: Scalars['Int']['output'];
  expectedShipments?: Maybe<Array<Maybe<ShipmentScheduleInformation>>>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  invoiceStatus?: Maybe<InvoiceStatus>;
  ipiTax?: Maybe<Money>;
  item?: Maybe<Product>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Money>;
  priceUnit?: Maybe<SalesUnit>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rejectionStatus?: Maybe<OrderEntryRejectionStatus>;
  salesUnit?: Maybe<SalesUnit>;
  shippedQuantity?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Money>;
  unitPrice?: Maybe<Money>;
  usagePeriod?: Maybe<Scalars['Int']['output']>;
}

export interface OrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface OrderEntryRejectionStatus extends Localizable {
  __typename?: 'OrderEntryRejectionStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface OrderEntryRejectionStatusNameArgs {
  localization: LocalizationInput;
}

export interface OrderPaginationResult extends PaginationResult {
  __typename?: 'OrderPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Order>>;
}

export interface OrderRejectionStatus extends Localizable {
  __typename?: 'OrderRejectionStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface OrderRejectionStatusNameArgs {
  localization: LocalizationInput;
}

export interface OrdersFilterInput {
  buyerContactId?: InputMaybe<Scalars['String']['input']>;
  deliveryStatus?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  salesChannel?: InputMaybe<Scalars['String']['input']>;
  shipToAccountId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtypes?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface OrderStatus extends Localizable {
  __typename?: 'OrderStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface OrderStatusNameArgs {
  localization: LocalizationInput;
}

export interface OrderTrackingDetails {
  __typename?: 'OrderTrackingDetails';
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  deliveryId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderTrackingStatus>;
  statusOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  trackingDetails?: Maybe<Array<Maybe<ShipmentTrackingDetails>>>;
}

export interface OrderTrackingDetailsResult {
  __typename?: 'OrderTrackingDetailsResult';
  orderTrackingDetails?: Maybe<Array<OrderTrackingDetails>>;
}

export enum OrderTrackingStatus {
  EXPECTED_DELAY = 'EXPECTED_DELAY',
  FAILED_DELIVERY_ATTEMPT = 'FAILED_DELIVERY_ATTEMPT',
  FAILED_PICKUP_ATTEMPT = 'FAILED_PICKUP_ATTEMPT',
  GOODS_ISSUE = 'GOODS_ISSUE',
  GOODS_RECEIPT = 'GOODS_RECEIPT',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  PICKING_AND_PACKING = 'PICKING_AND_PACKING',
  SUCCESSFUL_DELIVERY = 'SUCCESSFUL_DELIVERY',
  SUCCESSFUL_PICKUP = 'SUCCESSFUL_PICKUP'
}

export interface OrderType extends Localizable {
  __typename?: 'OrderType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface OrderTypeNameArgs {
  localization: LocalizationInput;
}

export interface Pageable {
  id: Scalars['ID']['output'];
}

export interface PageInfo {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
}

export interface PageInput {
  /** Cursor that indicates specific place on the list */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor that indicates specific place on the list */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Amount of results to be returned after provided cursor */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Amount of results to be returned before provided cursor */
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PaginationDetails {
  __typename?: 'PaginationDetails';
  /** The current page number */
  currentPage: Scalars['Int']['output'];
  /** Determines if there are more results in the data store */
  hasMorePages?: Maybe<Scalars['Boolean']['output']>;
  /** The page number of the last available page */
  lastPage?: Maybe<Scalars['Int']['output']>;
  /** The number of results to be shown per page */
  pageSize: Scalars['Int']['output'];
  /** The total number of matching results in the data store */
  totalResults?: Maybe<Scalars['Int']['output']>;
}

export interface PaginationInput {
  /** The desired results page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** The desired number of results per page */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}

export interface PaginationResult {
  /** The details needed to display and support pagination */
  paginationDetails: PaginationDetails;
  /** The results for the pagination query */
  results: Array<Maybe<Pageable>>;
}

export interface PaymentMethod extends Localizable {
  __typename?: 'PaymentMethod';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface PaymentMethodNameArgs {
  localization: LocalizationInput;
}

export interface PaymentTerms extends Localizable {
  __typename?: 'PaymentTerms';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface PaymentTermsNameArgs {
  localization: LocalizationInput;
}

export interface PeakPrice {
  __typename?: 'PeakPrice';
  dailyFee?: Maybe<Money>;
  isBelowMinimumRentalPeriod?: Maybe<Scalars['Boolean']['output']>;
  priceTiers?: Maybe<Array<PriceTier>>;
  rentalPeriod?: Maybe<Scalars['Int']['output']>;
  totalCost?: Maybe<Money>;
}

export interface PeakPriceFilterInput {
  currency: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rentalEndDate?: InputMaybe<Scalars['Date']['input']>;
  rentalStartDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface PeakToolOption {
  __typename?: 'PeakToolOption';
  hasSameLogisticToolType?: Maybe<Scalars['Boolean']['output']>;
  hasSamePricingToolType?: Maybe<Scalars['Boolean']['output']>;
  logisticProduct?: Maybe<Product>;
  product?: Maybe<Product>;
}

export enum Permission {
  BROWSE_ALL_CAMPAIGN_EVOUCHER = 'BROWSE_ALL_CAMPAIGN_EVOUCHER',
  BROWSE_ALL_CONSUMABLE_EVOUCHER = 'BROWSE_ALL_CONSUMABLE_EVOUCHER',
  BROWSE_CREATED_BY_CONSUMABLE_EVOUCHER = 'BROWSE_CREATED_BY_CONSUMABLE_EVOUCHER',
  BROWSE_CURRENT_CUSTOMER_EVOUCHER = 'BROWSE_CURRENT_CUSTOMER_EVOUCHER',
  BROWSE_EVOUCHER_CONFIG = 'BROWSE_EVOUCHER_CONFIG',
  CREATE_CAMPAIGN_EVOUCHER = 'CREATE_CAMPAIGN_EVOUCHER',
  CREATE_CONSUMABLE_EVOUCHER = 'CREATE_CONSUMABLE_EVOUCHER',
  DEACTIVATE_EVOUCHER = 'DEACTIVATE_EVOUCHER',
  DELETE_EVOUCHER = 'DELETE_EVOUCHER',
  REACTIVATE_EVOUCHER = 'REACTIVATE_EVOUCHER',
  REPORT_CAMPAIGN_EVOUCHER = 'REPORT_CAMPAIGN_EVOUCHER',
  REPORT_CONSUMABLE_EVOUCHER = 'REPORT_CONSUMABLE_EVOUCHER',
  REPORT_CREATED_BY_CONSUMABLE_EVOUCHER = 'REPORT_CREATED_BY_CONSUMABLE_EVOUCHER',
  UPDATE_EVOUCHER_CONFIG = 'UPDATE_EVOUCHER_CONFIG'
}

export interface Price {
  __typename?: 'Price';
  currency: Scalars['String']['output'];
  fleetDetails?: Maybe<FleetPriceDetails>;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  standardDetails?: Maybe<StandardPriceDetails>;
  subscriptionDetails?: Maybe<SubscriptionPriceDetails>;
}

export interface PriceInformation {
  __typename?: 'PriceInformation';
  discount?: Maybe<Money>;
  shippingCharges?: Maybe<Money>;
  subTotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
  totalBeforeTax?: Maybe<Money>;
}

export interface PricesFilterInput {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  products: Array<ProductPriceInput>;
  types: Array<PriceType>;
}

export interface PriceTier {
  __typename?: 'PriceTier';
  dailyFee?: Maybe<Money>;
  rentalFromDay?: Maybe<Scalars['Int']['output']>;
  rentalToDay?: Maybe<Scalars['Int']['output']>;
}

export enum PriceType {
  FLEET = 'FLEET',
  STANDARD = 'STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export interface Product extends Node {
  __typename?: 'Product';
  categoryGroup?: Maybe<ItemCategoryGroup>;
  /** This field should not be used directly, it was added for the product compound key in order to resolve reference */
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  incrementalOrderQuantity?: Maybe<Scalars['Int']['output']>;
  /** Flag to indicate if a product is not yet ready for purchase */
  isAvailableSoon?: Maybe<Scalars['Boolean']['output']>;
  isPurchasable?: Maybe<Scalars['Boolean']['output']>;
  /** This field should not be used directly, it was added for the product compound key in order to resolve reference */
  language: Scalars['String']['output'];
  minOrderQuantity?: Maybe<Scalars['Int']['output']>;
  packageContents?: Maybe<Array<Scalars['String']['output']>>;
  packagingUnit?: Maybe<Scalars['String']['output']>;
  rangeId?: Maybe<Scalars['String']['output']>;
  salesUnitOfMeasure?: Maybe<UnitOfMeasure>;
  softwareAttributes?: Maybe<SoftwareAttributes>;
  /** The technical attributes e.g voltage, battery capacity */
  technicalAttributes?: Maybe<Array<ProductTechnicalAttribute>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductType>;
  weight?: Maybe<Dimension>;
}

export interface ProductThumbnailArgs {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProductBannerFilterInput {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  journeyId: Scalars['UUID']['input'];
  /** CMS page template name, HomePage, etc */
  pageType?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Current page uri */
  uri: Scalars['String']['input'];
}

export interface ProductConfiguration {
  __typename?: 'ProductConfiguration';
  filters?: Maybe<Array<ProductConfigurationFilter>>;
  products?: Maybe<Array<Product>>;
}

export interface ProductConfigurationFilter {
  __typename?: 'ProductConfigurationFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<ProductConfigurationFilterType>;
  values?: Maybe<Array<ProductConfigurationFilterValue>>;
}

export enum ProductConfigurationFilterType {
  RADIO = 'RADIO',
  SELECT = 'SELECT'
}

export interface ProductConfigurationFilterValue {
  __typename?: 'ProductConfigurationFilterValue';
  applicableFilterValues?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  matchingProductIds?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
}

export enum ProductFamily {
  ANCHOR = 'ANCHOR',
  DIAMOND = 'DIAMOND',
  DIRECT_FASTENING = 'DIRECT_FASTENING',
  FIRE_PROTECTION = 'FIRE_PROTECTION',
  INSTALLATION_SYSTEMS = 'INSTALLATION_SYSTEMS',
  POWER_TOOLS_ACCESSORIES = 'POWER_TOOLS_ACCESSORIES',
  SCREW_FASTENING = 'SCREW_FASTENING'
}

export interface ProductFamilyUsage {
  __typename?: 'ProductFamilyUsage';
  productFamily: ProductFamily;
  usedAmount?: Maybe<Money>;
}

export interface ProductFeatureValue extends Node {
  __typename?: 'ProductFeatureValue';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
}

export interface ProductPriceInput {
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
}

export interface ProductSearch {
  __typename?: 'ProductSearch';
  id: Scalars['ID']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isNuron?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface ProductTechnicalAttribute {
  __typename?: 'ProductTechnicalAttribute';
  formattedValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export enum ProductType {
  ACCESSORY = 'ACCESSORY',
  BATTERIES_AND_CHARGERS = 'BATTERIES_AND_CHARGERS',
  CONSUMABLE = 'CONSUMABLE',
  INSERT = 'INSERT',
  SERVICE = 'SERVICE',
  SOFTWARE = 'SOFTWARE',
  TOOL = 'TOOL'
}

export interface PurchaseOrderDocument {
  __typename?: 'PurchaseOrderDocument';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
}

export interface PurchaseRequest extends Node, Pageable {
  __typename?: 'PurchaseRequest';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  fleetDetails?: Maybe<PurchaseRequestFleetDetails>;
  id: Scalars['ID']['output'];
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  purchaseTypes?: Maybe<Array<Maybe<PurchaseType>>>;
  rejectionComment?: Maybe<Scalars['String']['output']>;
  rejectionReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requester?: Maybe<Contact>;
  requesterComment?: Maybe<Scalars['String']['output']>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  softwareProfisEngineeringDetails?: Maybe<PurchaseRequestProfisEngineeringDetails>;
  standardDetails?: Maybe<PurchaseRequestStandardDetails>;
  status?: Maybe<PurchaseRequestStatus>;
  subscriptionMonthlyDetails?: Maybe<PurchaseRequestSubscriptionMonthlyDetails>;
  subscriptionYearlyDetails?: Maybe<PurchaseRequestSubscriptionYearlyDetails>;
  /** This is technical field, not shown in UI. The purpose of it is to distinguish any changes done by other users (approver) */
  updatedByContactOriginId?: Maybe<Scalars['String']['output']>;
}

export interface PurchaseRequestFleetDetails {
  __typename?: 'PurchaseRequestFleetDetails';
  items: Array<PurchaseRequestFleetEntry>;
  monthlyPriceInformation?: Maybe<PriceInformation>;
  upfrontPriceInformation?: Maybe<PriceInformation>;
}

export interface PurchaseRequestFleetEntry {
  __typename?: 'PurchaseRequestFleetEntry';
  fleetDetails?: Maybe<FleetDetails>;
  item?: Maybe<Product>;
  monthlyPriceInformation?: Maybe<ItemPriceInformation>;
  quantity: Scalars['Float']['output'];
  salesUnit?: Maybe<SalesUnit>;
  upfrontPriceInformation?: Maybe<ItemPriceInformation>;
}

export interface PurchaseRequestFleetEntryItemArgs {
  localization: LocalizationInput;
}

export interface PurchaseRequestPaginationResult extends PaginationResult {
  __typename?: 'PurchaseRequestPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<PurchaseRequest>>;
}

export interface PurchaseRequestProfisEngineeringDetails {
  __typename?: 'PurchaseRequestProfisEngineeringDetails';
  items: Array<PurchaseRequestSoftwareProfisEngineeringEntry>;
  priceInformation: PriceInformation;
}

export interface PurchaseRequestsFilterInput {
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<PurchaseRequestStatus>>;
}

export interface PurchaseRequestSoftwareProfisEngineeringEntry {
  __typename?: 'PurchaseRequestSoftwareProfisEngineeringEntry';
  item?: Maybe<Product>;
  itemPriceInformation: ItemPriceInformation;
  quantity: Scalars['Float']['output'];
  salesUnit?: Maybe<SalesUnit>;
}

export interface PurchaseRequestSoftwareProfisEngineeringEntryItemArgs {
  localization: LocalizationInput;
}

export interface PurchaseRequestStandardDetails {
  __typename?: 'PurchaseRequestStandardDetails';
  items: Array<PurchaseRequestStandardEntry>;
  priceInformation: PriceInformation;
}

export interface PurchaseRequestStandardEntry {
  __typename?: 'PurchaseRequestStandardEntry';
  item?: Maybe<Product>;
  itemPriceInformation: ItemPriceInformation;
  quantity: Scalars['Float']['output'];
  salesUnit?: Maybe<SalesUnit>;
}

export interface PurchaseRequestStandardEntryItemArgs {
  localization: LocalizationInput;
}

export enum PurchaseRequestStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED'
}

export interface PurchaseRequestSubscriptionEntry {
  __typename?: 'PurchaseRequestSubscriptionEntry';
  item?: Maybe<Product>;
  itemPriceInformation: ItemPriceInformation;
  quantity: Scalars['Float']['output'];
  salesUnit?: Maybe<SalesUnit>;
}

export interface PurchaseRequestSubscriptionEntryItemArgs {
  localization: LocalizationInput;
}

export interface PurchaseRequestSubscriptionMonthlyDetails {
  __typename?: 'PurchaseRequestSubscriptionMonthlyDetails';
  items: Array<PurchaseRequestSubscriptionEntry>;
  priceInformation: PriceInformation;
}

export interface PurchaseRequestSubscriptionYearlyDetails {
  __typename?: 'PurchaseRequestSubscriptionYearlyDetails';
  items: Array<PurchaseRequestSubscriptionEntry>;
  priceInformation: PriceInformation;
}

export enum PurchaseType {
  FLEET = 'FLEET',
  SOFTWARE_PE = 'SOFTWARE_PE',
  STANDARD = 'STANDARD',
  SUBSCRIPTION_MONTHLY = 'SUBSCRIPTION_MONTHLY',
  SUBSCRIPTION_YEARLY = 'SUBSCRIPTION_YEARLY'
}

export interface Query {
  __typename?: 'Query';
  accounts?: Maybe<AccountPaginationResult>;
  /** Fetches active consumable subscriptions of customer */
  activeConsumablesSubscriptions: ConsumablesSubscriptionPaginationResult;
  activeFleetMasterContract?: Maybe<FleetMasterContract>;
  addressSuggestion?: Maybe<Address>;
  availabilityStores?: Maybe<StoreSearchResults>;
  batterySelfRecyclingDocument?: Maybe<BatterySelfRecyclingDocument>;
  billingAddresses?: Maybe<AccountConnection>;
  categoriesByIds: Array<Category>;
  category: Category;
  checkFleetQuotationForAccountEVoucher?: Maybe<AccountEVoucherFleetQuotationInformation>;
  checkStandardQuotationForAccountEVoucher?: Maybe<AccountEVoucherStandardQuotationInformation>;
  circularityReports: CircularityReportsPaginationResult;
  /** Fetches subscription details */
  consumablesSubscription?: Maybe<ConsumablesSubscription>;
  consumablesSubscriptionMonthlyUsage: ConsumablesSubscriptionMonthlyUsagePaginationResult;
  consumablesSubscriptionProductUsage: ConsumablesSubscriptionProductUsagePaginationResult;
  consumablesSubscriptionTotalUsage?: Maybe<ConsumablesSubscriptionTotalUsage>;
  consumablesSubscriptionUsageFilters?: Maybe<ConsumablesSubscriptionUsageFilters>;
  contact: Contact;
  /** @deprecated Use contact query instead */
  contactByOriginId?: Maybe<Contact>;
  contacts?: Maybe<ContactConnection>;
  contactsAssignableToSubscription?: Maybe<ContactsAssignableToSubscriptionPayload>;
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  customerCareNote?: Maybe<CustomerCareNote>;
  customerCareNotes?: Maybe<CustomerCareNotePaginationResult>;
  customerEVoucherRestrictions?: Maybe<CustomerEVoucherRestrictions>;
  customerPrices?: Maybe<Array<Price>>;
  eContractingFleetExchangeOptions?: Maybe<Array<Maybe<ExchangeOption>>>;
  eContractingFleetInvoiceOptions: FleetInvoiceOptions;
  educationArticles?: Maybe<ArticlesPaginationResult>;
  educationEngineeringApplications?: Maybe<Array<EducationTeaser>>;
  educationQuestions?: Maybe<QuestionsPaginationResult>;
  educationQuickLinks?: Maybe<Array<Link>>;
  educationSeries?: Maybe<EducationSeriesPaginationResult>;
  educationTutorials?: Maybe<EducationTutorialsPaginationResult>;
  eVoucher?: Maybe<EVoucher>;
  eVoucherAccountRestrictedAccountsConfiguration?: Maybe<EVoucherRestrictedAccountsConfigurationPaginationResult>;
  /** @deprecated Use eVoucherAccountRestrictedAccountsConfiguration/eVoucherCampaignRestrictedAccountsConfiguration  */
  eVoucherAccountsAdministrationConfiguration?: Maybe<EVoucherAccountsAdministrationConfiguration>;
  eVoucherCampaignReportState?: Maybe<EVoucherCampaignReportState>;
  eVoucherCampaignRestrictedAccountsConfiguration?: Maybe<EVoucherRestrictedAccountsConfigurationPaginationResult>;
  eVoucherExtendedAdministrationConfiguration?: Maybe<EVoucherAdministrationConfiguration>;
  eVoucherExtendedProductsAdministrationConfiguration?: Maybe<EVoucherProductsAdministrationConfiguration>;
  eVoucherListReportState?: Maybe<EVoucherListReportState>;
  eVouchers?: Maybe<EVoucherPaginationResult>;
  eVoucherStoreConfiguration?: Maybe<EVoucherStoreConfiguration>;
  exchangeableBatteries?: Maybe<ToolsPaginationResult>;
  fleetEContract?: Maybe<EContract>;
  fleetEContractTemplate?: Maybe<EContractTemplate>;
  fleetLabelingTemplates: Array<Maybe<FleetLabelingTemplate>>;
  /** @deprecated use fleetLabelingTemplates, fleetOrganizationalReferencesAndCostCenters, eContractingFleetExchangeOptions and eContractingFleetInvoiceOptions instead */
  fleetMasterContractOptions?: Maybe<FleetMasterContractOptions>;
  fleetOrganizationalReferencesAndCostCenters?: Maybe<FleetOrganizationalReferencesAndCostCenters>;
  fleetQuotation?: Maybe<FleetQuotation>;
  fleetQuotations?: Maybe<FleetQuotationPaginationResult>;
  formConfiguration?: Maybe<FormConfiguration>;
  freeTextSearchResultsCount?: Maybe<FreeTextSearchResultsCount>;
  /** Omit filter to get default gridPageProductBanner */
  gridPageProductBanner?: Maybe<Banner>;
  /** Determines if a customer has at least one active consumable subscription */
  hasActiveConsumablesSubscriptions: Scalars['Boolean']['output'];
  hiltiCenter?: Maybe<HiltiCenter>;
  hiltiCenterBySlug?: Maybe<HiltiCenter>;
  inQuotationFleetMasterContract?: Maybe<FleetMasterContract>;
  isCartEligibleForCheckout: Scalars['Boolean']['output'];
  loanToolTrackingDetails?: Maybe<ToolTrackingDetails>;
  localizedOrderStatuses?: Maybe<Array<OrderStatus>>;
  localizedOrderTypes?: Maybe<Array<OrderType>>;
  localizedSalesChannels?: Maybe<Array<SalesChannel>>;
  loggedInContext?: Maybe<UserContext>;
  /** Get MakeItFit batteries compatible with a given tool by product id */
  makeItFitBatteriesForTool: Array<MakeItFitProduct>;
  /** Get MakeItFit chargers compatible with a given battery by product id */
  makeItFitChargersForBattery: Array<MakeItFitProduct>;
  /** Get MakeItFit chargers compatible with a given tool by product id */
  makeItFitChargersForTool: Array<MakeItFitProduct>;
  /** Get MakeItFit cross selling Inserts & Accessories for a given tool by product id */
  makeItFitCrossSellingToolsForTool: Array<MakeItFitProduct>;
  /** Get initial MakeItFit configuration for a range product */
  makeItFitToolsWithDefaultPackage?: Maybe<MakeItFitToolsWithDefaultPackage>;
  marketingBanner?: Maybe<Banner>;
  /** Get customer marketing consent options */
  marketingConsents?: Maybe<Array<MarketingConsent>>;
  /** Omit filter to get default megaMenuProductBanner */
  megaMenuProductBanner?: Maybe<Banner>;
  miniCart?: Maybe<Cart>;
  /** Omit categoryId to get the mega menu mini teaser banners */
  miniTeaserBanners?: Maybe<Array<MiniTeaserBanner>>;
  nextWebinar?: Maybe<Webinar>;
  orderDetails?: Maybe<OrderDetails>;
  orderDraft?: Maybe<OrderDraft>;
  orderDraftDeliveryMethodsShippingDetails?: Maybe<Array<DeliveryMethodShippingDetails>>;
  orderDraftDeliveryTypes?: Maybe<Array<DeliveryType>>;
  orderDraftPaymentMethods?: Maybe<Array<PaymentMethod>>;
  orders?: Maybe<OrderPaginationResult>;
  orderTrackingDetails?: Maybe<OrderTrackingDetailsResult>;
  peakPrice?: Maybe<PeakPrice>;
  peakToolOption?: Maybe<PeakToolOption>;
  product?: Maybe<Product>;
  productByEan?: Maybe<Product>;
  productConfiguration?: Maybe<ProductConfiguration>;
  productsByIds: Array<Product>;
  purchaseRequest?: Maybe<PurchaseRequest>;
  purchaseRequests: PurchaseRequestPaginationResult;
  quotationConfirmationDocument?: Maybe<QuotationConfirmationDocument>;
  repairNotificationFilters?: Maybe<RepairNotificationFilters>;
  repairNotifications?: Maybe<RepairNotificationsPaginationResult>;
  repairTrackingDetails?: Maybe<RepairTrackingDetails>;
  repairTrackingNotificationStatuses?: Maybe<RepairNotification>;
  returnToolsDetails?: Maybe<ReturnToolsDetails>;
  searchAddressSuggestions?: Maybe<Array<AddressSuggestion>>;
  searchAutoSuggestions: SearchAutoSuggestions;
  searchEditorials?: Maybe<SearchEditorialsPaginationResult>;
  searchFleetEContractTemplate?: Maybe<EContractTemplate>;
  shippingAddress: Account;
  /** @deprecated Use shippingAddress query instead */
  shippingAddressByOriginId?: Maybe<Account>;
  shippingAddresses?: Maybe<AccountConnection>;
  shippingStores?: Maybe<StoreSearchResults>;
  shoppingList?: Maybe<ShoppingList>;
  shoppingLists?: Maybe<ShoppingListPaginationResult>;
  softwareSubscription?: Maybe<SoftwareSubscription>;
  softwareSubscriptionAvailableProducts?: Maybe<Array<Maybe<Product>>>;
  softwareSubscriptionInvoicePaymentAllowed?: Maybe<SoftwareSubscriptionInvoicePaymentAllowedPayload>;
  softwareSubscriptionMasterAgreementAmendmentAllowed?: Maybe<SoftwareSubscriptionMasterAgreementAmendmentAllowedPayload>;
  softwareSubscriptionProductChangeOptions?: Maybe<Array<SoftwareSubscriptionProductChangeOption>>;
  softwareSubscriptions?: Maybe<SoftwareSubscriptionPaginationResult>;
  standardQuotation?: Maybe<StandardQuotation>;
  standardQuotations?: Maybe<StandardQuotationPaginationResult>;
  stockAvailability?: Maybe<StockLevels>;
  storeConfiguration?: Maybe<StoreConfiguration>;
  stores?: Maybe<StoreSearchResults>;
  storeWeeklyOpeningSchedule?: Maybe<WeeklyOpeningSchedule>;
  streetPrices?: Maybe<Array<Price>>;
  toolDocuments: Array<ToolDocument>;
  toolFilters?: Maybe<ToolFilters>;
  tools?: Maybe<ToolsPaginationResult>;
  toolsByEquipmentNumbers: Array<Tool>;
  toolsByIds: Array<Tool>;
  toolsCount?: Maybe<Scalars['Int']['output']>;
  topLevelProductNavigation: Array<Category>;
  warehouses?: Maybe<WarehouseSearchResults>;
}

export interface QueryAccountsArgs {
  pagination: PaginationInput;
}

export interface QueryActiveConsumablesSubscriptionsArgs {
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryActiveFleetMasterContractArgs {
  localization: LocalizationInput;
}

export interface QueryAddressSuggestionArgs {
  filter?: InputMaybe<AddressSuggestionFilterInput>;
  id: Scalars['ID']['input'];
}

export interface QueryAvailabilityStoresArgs {
  filter: StoreSearchFilterInput;
  localization: StoreSearchLocalizationInput;
  location: StoreSearchLocationInput;
}

export interface QueryBatterySelfRecyclingDocumentArgs {
  localization: LocalizationInput;
  productId: Scalars['ID']['input'];
}

export interface QueryBillingAddressesArgs {
  pagination: PageInput;
}

export interface QueryCategoriesByIdsArgs {
  ids: Array<Scalars['ID']['input']>;
  localization: LocalizationInput;
}

export interface QueryCategoryArgs {
  id: Scalars['ID']['input'];
  localization: LocalizationInput;
}

export interface QueryCheckFleetQuotationForAccountEVoucherArgs {
  quotationId: Scalars['String']['input'];
}

export interface QueryCheckStandardQuotationForAccountEVoucherArgs {
  quotationId: Scalars['String']['input'];
}

export interface QueryCircularityReportsArgs {
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryConsumablesSubscriptionArgs {
  id: Scalars['ID']['input'];
}

export interface QueryConsumablesSubscriptionMonthlyUsageArgs {
  filter?: InputMaybe<ConsumablesSubscriptionUsageFilterInput>;
  orderBy?: InputMaybe<ConsumablesSubscriptionMonthlyUsageOrderByInput>;
  pagination: PaginationInput;
}

export interface QueryConsumablesSubscriptionProductUsageArgs {
  filter?: InputMaybe<ConsumablesSubscriptionUsageFilterInput>;
  orderBy?: InputMaybe<ConsumablesSubscriptionProductUsageOrderByInput>;
  pagination: PaginationInput;
}

export interface QueryConsumablesSubscriptionTotalUsageArgs {
  filter?: InputMaybe<ConsumablesSubscriptionUsageFilterInput>;
}

export interface QueryConsumablesSubscriptionUsageFiltersArgs {
  filter?: InputMaybe<ConsumablesSubscriptionUsageFilterInput>;
}

export interface QueryContactArgs {
  id: Scalars['ID']['input'];
}

export interface QueryContactByOriginIdArgs {
  id: Scalars['ID']['input'];
}

export interface QueryContactsArgs {
  pagination: PageInput;
}

export interface QueryContactsAssignableToSubscriptionArgs {
  input?: InputMaybe<ContactsAssignableToSubscriptionInput>;
}

export interface QueryCurrencyExchangeRateArgs {
  currencyFrom: Scalars['String']['input'];
  currencyTo: Scalars['String']['input'];
}

export interface QueryCustomerCareNoteArgs {
  id: Scalars['ID']['input'];
}

export interface QueryCustomerCareNotesArgs {
  orderBy: CustomerCareNoteOrderByInput;
  pagination: PaginationInput;
}

export interface QueryCustomerPricesArgs {
  filter: CustomerPricesFilterInput;
}

export interface QueryEducationArticlesArgs {
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QueryEducationEngineeringApplicationsArgs {
  localization: LocalizationInput;
}

export interface QueryEducationQuestionsArgs {
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QueryEducationQuickLinksArgs {
  localization: LocalizationInput;
}

export interface QueryEducationSeriesArgs {
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QueryEducationTutorialsArgs {
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QueryEVoucherArgs {
  id: Scalars['ID']['input'];
}

export interface QueryEVoucherAccountRestrictedAccountsConfigurationArgs {
  filter?: InputMaybe<EVoucherRestrictedAccountsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryEVoucherCampaignReportStateArgs {
  id: Scalars['ID']['input'];
}

export interface QueryEVoucherCampaignRestrictedAccountsConfigurationArgs {
  filter?: InputMaybe<EVoucherRestrictedAccountsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryEVoucherListReportStateArgs {
  filter: EVoucherListReportStateFilterInput;
}

export interface QueryEVouchersArgs {
  filter?: InputMaybe<EVoucherFilterInput>;
  pagination: PaginationInput;
}

export interface QueryExchangeableBatteriesArgs {
  filter?: InputMaybe<ExchangeableBatteriesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryFleetEContractArgs {
  filter?: InputMaybe<FleetEContractTemplateFilterInput>;
  id: Scalars['ID']['input'];
}

export interface QueryFleetEContractTemplateArgs {
  id: Scalars['ID']['input'];
}

export interface QueryFleetLabelingTemplatesArgs {
  localization: LocalizationInput;
}

export interface QueryFleetMasterContractOptionsArgs {
  localization: LocalizationInput;
  masterContractId?: InputMaybe<Scalars['ID']['input']>;
}

export interface QueryFleetOrganizationalReferencesAndCostCentersArgs {
  masterContractId: Scalars['ID']['input'];
}

export interface QueryFleetQuotationArgs {
  id: Scalars['ID']['input'];
}

export interface QueryFleetQuotationsArgs {
  filter?: InputMaybe<QuotationsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryFormConfigurationArgs {
  localization: LocalizationInput;
  type: FormType;
}

export interface QueryFreeTextSearchResultsCountArgs {
  filter: FreeTextSearchResultsCountFilterInput;
}

export interface QueryGridPageProductBannerArgs {
  filter?: InputMaybe<ProductBannerFilterInput>;
  localization: LocalizationInput;
}

export interface QueryHiltiCenterArgs {
  id: Scalars['ID']['input'];
}

export interface QueryHiltiCenterBySlugArgs {
  slug: Scalars['String']['input'];
}

export interface QueryInQuotationFleetMasterContractArgs {
  localization: LocalizationInput;
}

export interface QueryIsCartEligibleForCheckoutArgs {
  cartId: Scalars['ID']['input'];
}

export interface QueryLoanToolTrackingDetailsArgs {
  loanOrderId: Scalars['ID']['input'];
  localization: LocalizationInput;
}

export interface QueryLocalizedOrderStatusesArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryLocalizedOrderTypesArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryLocalizedSalesChannelsArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryMakeItFitBatteriesForToolArgs {
  localization: LocalizationInput;
  productId: Scalars['ID']['input'];
}

export interface QueryMakeItFitChargersForBatteryArgs {
  localization: LocalizationInput;
  productId: Scalars['ID']['input'];
}

export interface QueryMakeItFitChargersForToolArgs {
  localization: LocalizationInput;
  productId: Scalars['ID']['input'];
}

export interface QueryMakeItFitCrossSellingToolsForToolArgs {
  localization: LocalizationInput;
  productId: Scalars['ID']['input'];
}

export interface QueryMakeItFitToolsWithDefaultPackageArgs {
  localization: LocalizationInput;
  rangeId: Scalars['ID']['input'];
}

export interface QueryMarketingBannerArgs {
  filter: MarketingBannerFilterInput;
  localization: LocalizationInput;
}

export interface QueryMegaMenuProductBannerArgs {
  filter?: InputMaybe<ProductBannerFilterInput>;
  localization: LocalizationInput;
}

export interface QueryMiniCartArgs {
  id: Scalars['ID']['input'];
}

export interface QueryMiniTeaserBannersArgs {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  localization: LocalizationInput;
}

export interface QueryNextWebinarArgs {
  localization: LocalizationInput;
}

export interface QueryOrderDetailsArgs {
  id: Scalars['ID']['input'];
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryOrderDraftArgs {
  id: Scalars['ID']['input'];
}

export interface QueryOrderDraftDeliveryMethodsShippingDetailsArgs {
  orderDraftId: Scalars['ID']['input'];
}

export interface QueryOrderDraftDeliveryTypesArgs {
  orderDraftId: Scalars['ID']['input'];
}

export interface QueryOrderDraftPaymentMethodsArgs {
  orderDraftId: Scalars['ID']['input'];
}

export interface QueryOrdersArgs {
  filter?: InputMaybe<OrdersFilterInput>;
  pagination: PaginationInput;
}

export interface QueryOrderTrackingDetailsArgs {
  orderId: Scalars['ID']['input'];
}

export interface QueryPeakPriceArgs {
  filter: PeakPriceFilterInput;
  productId: Scalars['ID']['input'];
}

export interface QueryPeakToolOptionArgs {
  localization: LocalizationInput;
  productId: Scalars['ID']['input'];
}

export interface QueryProductArgs {
  id: Scalars['ID']['input'];
  localization: LocalizationInput;
}

export interface QueryProductByEanArgs {
  ean: Scalars['String']['input'];
  localization: LocalizationInput;
}

export interface QueryProductConfigurationArgs {
  id: Scalars['ID']['input'];
}

export interface QueryProductsByIdsArgs {
  ids: Array<Scalars['ID']['input']>;
  localization: LocalizationInput;
}

export interface QueryPurchaseRequestArgs {
  id: Scalars['ID']['input'];
}

export interface QueryPurchaseRequestsArgs {
  filter?: InputMaybe<PurchaseRequestsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryQuotationConfirmationDocumentArgs {
  quotationId: Scalars['ID']['input'];
}

export interface QueryRepairNotificationFiltersArgs {
  filter?: InputMaybe<RepairNotificationFiltersInput>;
}

export interface QueryRepairNotificationsArgs {
  filter?: InputMaybe<RepairNotificationsFilterInput>;
  orderBy?: InputMaybe<RepairNotificationsOrderByInput>;
  pagination: PaginationInput;
}

export interface QueryRepairTrackingDetailsArgs {
  localization: LocalizationInput;
  repairNotificationId: Scalars['ID']['input'];
}

export interface QueryRepairTrackingNotificationStatusesArgs {
  localization: LocalizationInput;
  repairNotificationKey: Scalars['String']['input'];
}

export interface QueryReturnToolsDetailsArgs {
  filter?: InputMaybe<ReturnToolsDetailsFilterInput>;
}

export interface QuerySearchAddressSuggestionsArgs {
  filter: AddressSuggestionFilterInput;
}

export interface QuerySearchAutoSuggestionsArgs {
  filter: SearchAutoSuggestionsFilterInput;
}

export interface QuerySearchEditorialsArgs {
  filter: SearchEditorialsFilterInput;
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QuerySearchFleetEContractTemplateArgs {
  filter: FleetEContractTemplateFilterInput;
}

export interface QueryShippingAddressArgs {
  id: Scalars['ID']['input'];
}

export interface QueryShippingAddressByOriginIdArgs {
  id: Scalars['ID']['input'];
}

export interface QueryShippingAddressesArgs {
  pagination: PageInput;
}

export interface QueryShippingStoresArgs {
  filter: StoreSearchFilterInput;
  localization: StoreSearchLocalizationInput;
  location: StoreSearchLocationInput;
}

export interface QueryShoppingListArgs {
  id: Scalars['ID']['input'];
}

export interface QueryShoppingListsArgs {
  filter?: InputMaybe<ShoppingListsFilterInput>;
  orderBy?: InputMaybe<ShoppingListsOrderByInput>;
  pagination: PaginationInput;
}

export interface QuerySoftwareSubscriptionArgs {
  id: Scalars['ID']['input'];
}

export interface QuerySoftwareSubscriptionAvailableProductsArgs {
  localization: LocalizationInput;
}

export interface QuerySoftwareSubscriptionInvoicePaymentAllowedArgs {
  input: SoftwareSubscriptionInvoicePaymentAllowedInput;
}

export interface QuerySoftwareSubscriptionMasterAgreementAmendmentAllowedArgs {
  input?: InputMaybe<SoftwareSubscriptionMasterAgreementAmendmentAllowedInput>;
}

export interface QuerySoftwareSubscriptionProductChangeOptionsArgs {
  input?: InputMaybe<SoftwareSubscriptionProductChangeOptionsInput>;
}

export interface QuerySoftwareSubscriptionsArgs {
  filter?: InputMaybe<SoftwareSubscriptionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryStandardQuotationArgs {
  id: Scalars['ID']['input'];
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryStandardQuotationsArgs {
  filter?: InputMaybe<QuotationsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryStockAvailabilityArgs {
  input: StockAvailabilityFilterInput;
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryStoreConfigurationArgs {
  localization: LocalizationInput;
}

export interface QueryStoresArgs {
  filter: StoreSearchFilterInput;
  localization: StoreSearchLocalizationInput;
  location: StoreSearchLocationInput;
}

export interface QueryStoreWeeklyOpeningScheduleArgs {
  localization: LocalizationInput;
}

export interface QueryStreetPricesArgs {
  filter: PricesFilterInput;
}

export interface QueryToolDocumentsArgs {
  toolId: Scalars['ID']['input'];
}

export interface QueryToolFiltersArgs {
  filter?: InputMaybe<ToolFiltersInput>;
}

export interface QueryToolsArgs {
  filter?: InputMaybe<ToolsFilterInput>;
  orderBy?: InputMaybe<ToolsOrderByInput>;
  pagination: PaginationInput;
}

export interface QueryToolsByEquipmentNumbersArgs {
  equipmentNumbers: Array<Scalars['String']['input']>;
}

export interface QueryToolsByIdsArgs {
  ids: Array<Scalars['ID']['input']>;
}

export interface QueryToolsCountArgs {
  filter?: InputMaybe<ToolsFilterInput>;
}

export interface QueryTopLevelProductNavigationArgs {
  localization: LocalizationInput;
}

export interface QueryWarehousesArgs {
  filter: WarehouseSearchFilterInput;
}

export interface Question extends Node, Pageable {
  __typename?: 'Question';
  author?: Maybe<Author>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hasAcceptedAnswer?: Maybe<Scalars['Boolean']['output']>;
  hasVerifiedAnswer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  numberOfAnswers?: Maybe<Scalars['Int']['output']>;
  numberOfLikes?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the particular question in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']['output']>;
  /** Tag or Keywords for the question */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface QuestionsPaginationResult extends PaginationResult {
  __typename?: 'QuestionsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Question>>;
}

export interface QuickAddToCartInput {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  items: Array<CartItemInput>;
  localization: LocalizationInput;
}

export interface QuotationConfirmationDocument {
  __typename?: 'QuotationConfirmationDocument';
  quotationId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
}

export interface QuotationsFilterInput {
  buyerContactId?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  salesChannel?: InputMaybe<Scalars['String']['input']>;
  shipToAccountId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
}

export enum QuotationStatus {
  COMPLETED = 'COMPLETED',
  CONVERTED = 'CONVERTED',
  EXPIRED = 'EXPIRED',
  IN_PROCESS = 'IN_PROCESS',
  OPEN = 'OPEN',
  PARTIALLY_CONVERTED = 'PARTIALLY_CONVERTED'
}

export interface ReactivateEVoucherInput {
  id: Scalars['ID']['input'];
  reactivationReason: Scalars['String']['input'];
}

export interface ReactivateEVoucherPayload {
  __typename?: 'ReactivateEVoucherPayload';
  eVoucherId: Scalars['ID']['output'];
}

export interface ReassignSoftwareSubscriptionContactInput {
  email: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
}

export interface ReassignSoftwareSubscriptionContactPayload {
  __typename?: 'ReassignSoftwareSubscriptionContactPayload';
  user?: Maybe<LicenseUserAssignment>;
}

export interface ReassignSoftwareSubscriptionContactsInput {
  emails: Array<Scalars['String']['input']>;
  licenseActivationCode: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
}

export interface ReassignSoftwareSubscriptionContactsPayload {
  __typename?: 'ReassignSoftwareSubscriptionContactsPayload';
  users: Array<Maybe<LicenseUserAssignment>>;
}

export interface RecycleBatteriesDecisionPayload {
  __typename?: 'RecycleBatteriesDecisionPayload';
  toolIds: Array<Maybe<Scalars['String']['output']>>;
}

export interface RecycleBatteriesInput {
  toolIds: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface RecycleToolsForRepairNotificationsInput {
  repairNotificationIds: Array<Scalars['String']['input']>;
}

export interface Region extends Localizable {
  __typename?: 'Region';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface RegionNameArgs {
  localization: LocalizationInput;
}

export interface RegisterAddressInput {
  additionalGeoCode?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company2?: InputMaybe<Scalars['String']['input']>;
  company3?: InputMaybe<Scalars['String']['input']>;
  company4?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  pobox?: InputMaybe<Scalars['String']['input']>;
  postalcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetname?: InputMaybe<Scalars['String']['input']>;
  streetname2?: InputMaybe<Scalars['String']['input']>;
  streetname3?: InputMaybe<Scalars['String']['input']>;
  streetname4?: InputMaybe<Scalars['String']['input']>;
  streetname5?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface RegisterCompanyAccountInput {
  address: RegisterAddressInput;
  customerTax?: InputMaybe<Scalars['String']['input']>;
  customerType?: InputMaybe<CustomerType>;
  icmsTaxPayer?: InputMaybe<Scalars['String']['input']>;
  legalRepresentative?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  professionalDescription?: InputMaybe<Scalars['String']['input']>;
  taxJurisdiction?: InputMaybe<Scalars['String']['input']>;
  taxNumber1?: InputMaybe<Scalars['String']['input']>;
  taxNumber2?: InputMaybe<Scalars['String']['input']>;
  taxNumber3?: InputMaybe<Scalars['String']['input']>;
  taxNumber4?: InputMaybe<Scalars['String']['input']>;
  taxNumber5?: InputMaybe<Scalars['String']['input']>;
  taxOffice?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<Scalars['String']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
  tradeName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface RegisterContactInput {
  academicTitle?: InputMaybe<Scalars['String']['input']>;
  authorizedForHiltiOnline?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface RegisterCustomerInput {
  companyAccount?: InputMaybe<RegisterCompanyAccountInput>;
  contact?: InputMaybe<RegisterContactInput>;
}

export interface RegisterCustomerPayload {
  __typename?: 'RegisterCustomerPayload';
  customerRegistrationId: Scalars['ID']['output'];
}

export interface RegistrationCompanyAccount {
  __typename?: 'RegistrationCompanyAccount';
  address: Address;
  name?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  trade?: Maybe<Scalars['String']['output']>;
}

export interface RegistrationContact {
  __typename?: 'RegistrationContact';
  academicTitle?: Maybe<ContactAcademicTitle>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<ContactFunction>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<ContactTitle>;
}

export interface RegistrationContactInput {
  academicTitle?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface RegistrationContactPayload {
  __typename?: 'RegistrationContactPayload';
  registrationUserId: Scalars['ID']['output'];
}

export interface RejectFleetQuotationInput {
  quotationId: Scalars['ID']['input'];
}

export interface RejectPurchaseRequestInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface ReleaseOrderDraftEVoucherInput {
  orderDraftId: Scalars['ID']['input'];
}

export interface ReleaseOrderDraftEVoucherPayload {
  __typename?: 'ReleaseOrderDraftEVoucherPayload';
  orderDraft: OrderDraft;
}

export interface RemoveAllAccountsFromCampaignEVoucherPayload {
  __typename?: 'RemoveAllAccountsFromCampaignEVoucherPayload';
  eVoucherId: Scalars['ID']['output'];
}

export interface RemoveAllSoftwareSubscriptionScheduledAmendmentsInput {
  subscriptionId: Scalars['ID']['input'];
}

export interface RemoveAllSoftwareSubscriptionScheduledAmendmentsPayload {
  __typename?: 'RemoveAllSoftwareSubscriptionScheduledAmendmentsPayload';
  eContract?: Maybe<EContract>;
}

export interface RemoveCartInput {
  cartId: Scalars['ID']['input'];
}

export interface RemoveCartPayload {
  __typename?: 'RemoveCartPayload';
  status?: Maybe<RemoveCartStatus>;
}

export enum RemoveCartStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface RemoveItemsFromShoppingListInput {
  itemIds: Array<Scalars['String']['input']>;
  shoppingListId: Scalars['ID']['input'];
}

export interface RemoveItemsFromShoppingListPayload {
  __typename?: 'RemoveItemsFromShoppingListPayload';
  itemIds?: Maybe<Array<Scalars['String']['output']>>;
}

export interface ReorderToolsLabelsInput {
  shippingAddressOriginId: Scalars['String']['input'];
  shippingContactOriginId: Scalars['String']['input'];
  tools: Array<ChangeToolLabelsInput>;
}

export interface RepairNotification extends Node, Pageable {
  __typename?: 'RepairNotification';
  creationDate?: Maybe<Scalars['Date']['output']>;
  defects?: Maybe<Array<Maybe<ToolDefectInformation>>>;
  /** This is a technical field, not shown in UI - it was added to resolve tracking details based on deliveryId from repair-orders endpoint */
  deliveryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loanOrder?: Maybe<Order>;
  repairCost?: Maybe<Money>;
  repairOrder?: Maybe<Order>;
  status?: Maybe<RepairNotificationStatus>;
  tool?: Maybe<Tool>;
  trackingDetails?: Maybe<ShipmentTrackingDetails>;
  trackingEvents?: Maybe<Array<RepairTrackingEvent>>;
  /** Current tracking status of the repair notification, also included in the trackingEvents list */
  trackingStatus?: Maybe<RepairNotificationTrackingStatus>;
  tradeInQuotationDetails?: Maybe<ToolTradeInQuotationDetails>;
}

export interface RepairNotificationTrackingDetailsArgs {
  localization: LocalizationInput;
}

export interface RepairNotificationFilters {
  __typename?: 'RepairNotificationFilters';
  toolCostCenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toolInventoryNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toolOrganizationalReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toolTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface RepairNotificationFiltersInput {
  toolCostCenter?: InputMaybe<Scalars['String']['input']>;
  toolInventoryNumber?: InputMaybe<Scalars['String']['input']>;
  toolOrganizationalReference?: InputMaybe<Scalars['String']['input']>;
  toolType?: InputMaybe<Scalars['String']['input']>;
}

export interface RepairNotificationsFilterInput {
  country?: InputMaybe<Scalars['String']['input']>;
  includeCurrentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<RepairNotificationStatus>>>;
  toolCostCenter?: InputMaybe<Scalars['String']['input']>;
  toolInventoryNumber?: InputMaybe<Scalars['String']['input']>;
  toolOrganizationalReference?: InputMaybe<Scalars['String']['input']>;
  toolType?: InputMaybe<Scalars['String']['input']>;
}

export interface RepairNotificationsOrderByInput {
  creationDate?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  toolCostCenter?: InputMaybe<Sort>;
  toolOrganizationalReference?: InputMaybe<Sort>;
  toolSerialNumber?: InputMaybe<Sort>;
  toolType?: InputMaybe<Sort>;
}

export interface RepairNotificationsPaginationResult extends PaginationResult {
  __typename?: 'RepairNotificationsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<RepairNotification>>;
}

export enum RepairNotificationStatus {
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN'
}

export enum RepairNotificationTrackingStatus {
  ARRIVED_AT_TSC = 'ARRIVED_AT_TSC',
  BOUGHT_NEW_AND_RECYCLED = 'BOUGHT_NEW_AND_RECYCLED',
  DELAYED_EXCEPTIONAL_VOLUME = 'DELAYED_EXCEPTIONAL_VOLUME',
  DELAYED_WAITING_SPAREPARTS = 'DELAYED_WAITING_SPAREPARTS',
  EXPECT_DELAYS = 'EXPECT_DELAYS',
  FAILED_DELIVERY = 'FAILED_DELIVERY',
  IN_DELIVERY_PHASE = 'IN_DELIVERY_PHASE',
  IN_TRANSIT = 'IN_TRANSIT',
  ORDER_RECEIVED = 'ORDER_RECEIVED',
  PACKAGING_ARRIVED = 'PACKAGING_ARRIVED',
  PACKAGING_DISPATCHED = 'PACKAGING_DISPATCHED',
  PICK_UP = 'PICK_UP',
  PICK_UP_DELAYED = 'PICK_UP_DELAYED',
  PICK_UP_FAILED = 'PICK_UP_FAILED',
  QUOTATION_APPROVED = 'QUOTATION_APPROVED',
  READY_FOR_SHIPMENT = 'READY_FOR_SHIPMENT',
  RECYCLED = 'RECYCLED',
  RETURNED = 'RETURNED',
  SENT_BACK_UNREPAIRED = 'SENT_BACK_UNREPAIRED',
  START_TOOL_SERVICE = 'START_TOOL_SERVICE',
  WAITING_QUOTATION_DECISION = 'WAITING_QUOTATION_DECISION'
}

export interface RepairQuotationDecisionPayload {
  __typename?: 'RepairQuotationDecisionPayload';
  repairNotificationIds: Array<Scalars['String']['output']>;
}

export interface RepairTrackingDetails {
  __typename?: 'RepairTrackingDetails';
  billToAccount?: Maybe<Account>;
  hasParentRepairNotification?: Maybe<Scalars['Boolean']['output']>;
  mainRepairNotification: RepairNotification;
  pickUpAccount?: Maybe<Account>;
  pickUpCarrierInstructions?: Maybe<Scalars['String']['output']>;
  pickUpContactName?: Maybe<Scalars['String']['output']>;
  pickUpContactPhone?: Maybe<Scalars['String']['output']>;
  pickUpDate?: Maybe<Scalars['Date']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quotationApprovalContact?: Maybe<Contact>;
  relatedRepairNotifications?: Maybe<Array<RepairNotification>>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToCarrierInstructions?: Maybe<Scalars['String']['output']>;
  shipToContactName?: Maybe<Scalars['String']['output']>;
  shipToContactPhone?: Maybe<Scalars['String']['output']>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
}

export interface RepairTrackingEvent {
  __typename?: 'RepairTrackingEvent';
  estimatedDateFrom?: Maybe<Scalars['DateTime']['output']>;
  estimatedDateTo?: Maybe<Scalars['DateTime']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  status: RepairNotificationTrackingStatus;
}

export interface ReportLostToolInput {
  isReplacementNeeded: Scalars['Boolean']['input'];
  productImageUrl?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
}

export interface ReportLostToolsInput {
  carrierInstructions?: InputMaybe<Scalars['String']['input']>;
  oathDeclaration?: InputMaybe<ReportLostToolsOathDeclarationInput>;
  shippingAddressOriginId?: InputMaybe<Scalars['String']['input']>;
  shippingContactOriginId?: InputMaybe<Scalars['String']['input']>;
  tools: Array<ReportLostToolInput>;
}

export interface ReportLostToolsOathDeclarationInput {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  titleId?: InputMaybe<Scalars['String']['input']>;
}

export interface ReportStolenToolInput {
  isReplacementNeeded: Scalars['Boolean']['input'];
  policeAdditionalNotes: Scalars['String']['input'];
  policeReportCaseNumber: Scalars['String']['input'];
  productImageUrl?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
}

export interface ReportStolenToolsInput {
  carrierInstructions?: InputMaybe<Scalars['String']['input']>;
  policeReportFileId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressOriginId?: InputMaybe<Scalars['String']['input']>;
  shippingContactOriginId?: InputMaybe<Scalars['String']['input']>;
  tools: Array<ReportStolenToolInput>;
}

export interface ReprintOrderDeliveryNotesInput {
  deliveryIds: Array<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
}

export interface ReprintOrderDeliveryNotesPayload {
  __typename?: 'ReprintOrderDeliveryNotesPayload';
  failedDeliveryIds?: Maybe<Array<Scalars['String']['output']>>;
  manualResendRequiredDeliveryIds?: Maybe<Array<Scalars['String']['output']>>;
  successfulDeliveryIds?: Maybe<Array<Scalars['String']['output']>>;
}

export interface ResendFleetQuotationConfirmationInput {
  email: Scalars['String']['input'];
  quotationId: Scalars['ID']['input'];
}

export interface ResendFleetQuotationConfirmationPayload {
  __typename?: 'ResendFleetQuotationConfirmationPayload';
  quotationId: Scalars['ID']['output'];
}

export interface ResendOrderConfirmationInput {
  email: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
}

export interface ResendOrderConfirmationPayload {
  __typename?: 'ResendOrderConfirmationPayload';
  orderId: Scalars['ID']['output'];
}

export interface ResendQuotationConfirmationInput {
  email: Scalars['String']['input'];
  quotationId: Scalars['ID']['input'];
}

export interface ResendQuotationConfirmationPayload {
  __typename?: 'ResendQuotationConfirmationPayload';
  quotationId: Scalars['ID']['output'];
}

export interface ReturnToolInformation {
  __typename?: 'ReturnToolInformation';
  isBatteryDriven?: Maybe<Scalars['Boolean']['output']>;
  isDangerous?: Maybe<Scalars['Boolean']['output']>;
  isPackagingRecommended?: Maybe<Scalars['Boolean']['output']>;
  tool?: Maybe<Tool>;
}

export interface ReturnToolInput {
  isInOriginalCase: Scalars['Boolean']['input'];
  isPackagingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  productThumbnail?: InputMaybe<Scalars['String']['input']>;
  productTitle?: InputMaybe<Scalars['String']['input']>;
  toolId: Scalars['String']['input'];
}

export interface ReturnToolsDetails {
  __typename?: 'ReturnToolsDetails';
  earliestPickUpDate?: Maybe<Scalars['DateTime']['output']>;
  toolsInformation?: Maybe<Array<Maybe<ReturnToolInformation>>>;
}

export interface ReturnToolsDetailsFilterInput {
  toolIds: Array<InputMaybe<Scalars['String']['input']>>;
}

export interface ReturnToolsInput {
  numberOfPackages: Scalars['Int']['input'];
  pickUpAccountOriginId?: InputMaybe<Scalars['String']['input']>;
  pickUpCarrierInstructions?: InputMaybe<Scalars['String']['input']>;
  pickUpContactOriginId?: InputMaybe<Scalars['String']['input']>;
  pickUpDate?: InputMaybe<Scalars['Date']['input']>;
  returnMethod?: InputMaybe<ToolReturnMethod>;
  tools: Array<ReturnToolInput>;
}

export interface Role extends Node {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Maybe<Permission>>>;
  type: RoleType;
}

export enum RoleType {
  EVOUCHER_BACKOFFICE_USER = 'EVOUCHER_BACKOFFICE_USER'
}

export interface SalesChannel extends Localizable {
  __typename?: 'SalesChannel';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface SalesChannelNameArgs {
  localization: LocalizationInput;
}

export interface SalesUnit extends Localizable {
  __typename?: 'SalesUnit';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
}

export interface SalesUnitNameArgs {
  localization: LocalizationInput;
}

export interface SaveCustomerJourneyInput {
  journeyId?: InputMaybe<Scalars['UUID']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
}

export interface SaveCustomerJourneyPayload {
  __typename?: 'SaveCustomerJourneyPayload';
  journeyId: Scalars['UUID']['output'];
}

export interface SaveInProgressCustomerRegistrationInput {
  companyAccount?: InputMaybe<InProgressCompanyAccountRegistrationInput>;
  contact?: InputMaybe<InProgressContactRegistrationInput>;
}

export interface SaveInProgressCustomerRegistrationPayload {
  __typename?: 'SaveInProgressCustomerRegistrationPayload';
  registrationUserId: Scalars['ID']['output'];
}

export interface SearchAutoSuggestions {
  __typename?: 'SearchAutoSuggestions';
  categories: Array<CategorySearch>;
  products: Array<ProductSearch>;
}

export interface SearchAutoSuggestionsFilterInput {
  includeSpecialProducts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  localization: LocalizationInput;
  query: Scalars['String']['input'];
}

export interface SearchEditorial extends Pageable {
  __typename?: 'SearchEditorial';
  id: Scalars['ID']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface SearchEditorialsFilterInput {
  query: Scalars['String']['input'];
}

export interface SearchEditorialsPaginationResult extends PaginationResult {
  __typename?: 'SearchEditorialsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<SearchEditorial>;
}

export interface SendMessageToCustomerServiceInput {
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The user response token provided by the reCAPTCHA client-side integration. */
  token?: InputMaybe<Scalars['String']['input']>;
}

export interface SendMessageToCustomerServicePayload {
  __typename?: 'SendMessageToCustomerServicePayload';
  status?: Maybe<CustomerServiceMessageStatus>;
}

export interface ShipmentInformation {
  __typename?: 'ShipmentInformation';
  id: Scalars['ID']['output'];
  isDelivered?: Maybe<Scalars['Boolean']['output']>;
  isShipped?: Maybe<Scalars['Boolean']['output']>;
  shipmentItems: Array<ShipmentItem>;
  trackingDetails?: Maybe<ShipmentTrackingDetails>;
}

export interface ShipmentItem {
  __typename?: 'ShipmentItem';
  deliveredQuantity?: Maybe<Scalars['Float']['output']>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  requestedQuantity?: Maybe<Scalars['Float']['output']>;
}

export interface ShipmentItemProductArgs {
  localization: LocalizationInput;
}

export interface ShipmentScheduleInformation {
  __typename?: 'ShipmentScheduleInformation';
  date?: Maybe<Scalars['Date']['output']>;
  shipmentEntryNumber?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<SalesUnit>;
}

export interface ShipmentTrackingDetails {
  __typename?: 'ShipmentTrackingDetails';
  carrierName?: Maybe<Scalars['String']['output']>;
  hasTrackingUrl?: Maybe<Scalars['Boolean']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingURL?: Maybe<Scalars['String']['output']>;
}

export interface ShoppingList extends Node, Pageable {
  __typename?: 'ShoppingList';
  account?: Maybe<Account>;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Contact>;
  creationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  items?: Maybe<ShoppingListItemPaginationResult>;
  itemsCount: Scalars['Int']['output'];
  modificationDate?: Maybe<Scalars['Date']['output']>;
  modifiedBy?: Maybe<Contact>;
  name: Scalars['String']['output'];
}

export interface ShoppingListItemsArgs {
  pagination: PaginationInput;
}

export interface ShoppingListItem extends Node, Pageable {
  __typename?: 'ShoppingListItem';
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  purchaseType?: Maybe<ShoppingListItemPurchaseType>;
  quantity: Scalars['Float']['output'];
}

export interface ShoppingListItemProductArgs {
  localization: LocalizationInput;
}

export interface ShoppingListItemInput {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}

export interface ShoppingListItemPaginationResult extends PaginationResult {
  __typename?: 'ShoppingListItemPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<ShoppingListItem>>;
}

export enum ShoppingListItemPurchaseType {
  FLEET = 'FLEET',
  STANDARD = 'STANDARD'
}

export interface ShoppingListPaginationResult extends PaginationResult {
  __typename?: 'ShoppingListPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<ShoppingList>>;
}

export interface ShoppingListsFilterInput {
  type: ShoppingListType;
}

export interface ShoppingListsOrderByInput {
  createdBy?: InputMaybe<Sort>;
  creationDate?: InputMaybe<Sort>;
  itemsCount?: InputMaybe<Sort>;
  modificationDate?: InputMaybe<Sort>;
  modifiedBy?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
}

export enum ShoppingListType {
  COMPANY = 'COMPANY',
  PRIVATE = 'PRIVATE'
}

export interface SignFleetQuotationInput {
  quotationId: Scalars['ID']['input'];
}

export interface SoftwareAttributes {
  __typename?: 'SoftwareAttributes';
  licenseCategory?: Maybe<ProductFeatureValue>;
  loginUrl?: Maybe<Scalars['String']['output']>;
  userManagementUrl?: Maybe<Scalars['String']['output']>;
}

export interface SoftwareSubscription extends Node, Pageable {
  __typename?: 'SoftwareSubscription';
  adminContact?: Maybe<Contact>;
  billingCycle?: Maybe<BillingCycle>;
  creditCardDetails?: Maybe<CreditCardDetails>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hasMissingPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  hasPendingAmendment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latestModification?: Maybe<SoftwareSubscriptionModification>;
  licenseActivationCode?: Maybe<Scalars['String']['output']>;
  licenseGroupId?: Maybe<Scalars['Int']['output']>;
  licenseQuantity?: Maybe<Scalars['Int']['output']>;
  masterAgreementAmendmentUri?: Maybe<Scalars['String']['output']>;
  masterAgreementLicenseUri?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<SoftwareSubscriptionPermission>>;
  price?: Maybe<Money>;
  product?: Maybe<Product>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  refundPrice?: Maybe<Money>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SoftwareSubscriptionStatus>;
  userCount?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<LicenseUserAssignment>>>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
}

export interface SoftwareSubscriptionProductArgs {
  localization: LocalizationInput;
}

export interface SoftwareSubscriptionRefundPriceArgs {
  effectiveDate: Scalars['Date']['input'];
}

export enum SoftwareSubscriptionAssignmentStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED'
}

export interface SoftwareSubscriptionChangePaymentMethodToInvoiceInput {
  subscriptionId: Scalars['ID']['input'];
  subscriptionVersion: Scalars['Int']['input'];
}

export interface SoftwareSubscriptionChangePaymentMethodToInvoicePayload {
  __typename?: 'SoftwareSubscriptionChangePaymentMethodToInvoicePayload';
  softwareSubscription: SoftwareSubscription;
}

export interface SoftwareSubscriptionContactAssignmentStatus {
  __typename?: 'SoftwareSubscriptionContactAssignmentStatus';
  assigned: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
}

export interface SoftwareSubscriptionFilterInput {
  statuses?: InputMaybe<Array<InputMaybe<SoftwareSubscriptionStatus>>>;
}

export interface SoftwareSubscriptionInvoicePaymentAllowedInput {
  subscriptionId: Scalars['ID']['input'];
  subscriptionVersion: Scalars['Int']['input'];
}

export interface SoftwareSubscriptionInvoicePaymentAllowedPayload {
  __typename?: 'SoftwareSubscriptionInvoicePaymentAllowedPayload';
  isChangeToInvoiceAllowed: Scalars['Boolean']['output'];
}

export interface SoftwareSubscriptionMasterAgreementAmendmentAllowedInput {
  eContractId: Scalars['ID']['input'];
}

export interface SoftwareSubscriptionMasterAgreementAmendmentAllowedPayload {
  __typename?: 'SoftwareSubscriptionMasterAgreementAmendmentAllowedPayload';
  isMasterAgreementAmendmentAllowed: Scalars['Boolean']['output'];
}

export interface SoftwareSubscriptionModification {
  __typename?: 'SoftwareSubscriptionModification';
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  items?: Maybe<Array<Maybe<SoftwareSubscriptionModificationItem>>>;
}

export interface SoftwareSubscriptionModificationItem {
  __typename?: 'SoftwareSubscriptionModificationItem';
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
}

export interface SoftwareSubscriptionModificationItemProductArgs {
  localization: LocalizationInput;
}

export interface SoftwareSubscriptionPaginationResult extends PaginationResult {
  __typename?: 'SoftwareSubscriptionPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<SoftwareSubscription>>;
}

export enum SoftwareSubscriptionPermission {
  ACTIVATE_LEGACY = 'ACTIVATE_LEGACY',
  CHANGE_LICENSE = 'CHANGE_LICENSE',
  CHANGE_LICENSE_WITH_QUANTITY = 'CHANGE_LICENSE_WITH_QUANTITY',
  CHANGE_QUANTITY = 'CHANGE_QUANTITY',
  IMMEDIATE_CANCELLATION = 'IMMEDIATE_CANCELLATION',
  MANAGE_USERS = 'MANAGE_USERS',
  OVERRIDE_PRICE = 'OVERRIDE_PRICE'
}

export interface SoftwareSubscriptionProductChangeOption {
  __typename?: 'SoftwareSubscriptionProductChangeOption';
  billingCycle?: Maybe<BillingCycle>;
  product?: Maybe<Product>;
}

export interface SoftwareSubscriptionProductChangeOptionProductArgs {
  localization: LocalizationInput;
}

export interface SoftwareSubscriptionProductChangeOptionsInput {
  productId: Scalars['ID']['input'];
}

export enum SoftwareSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  ACTIVE_LEGACY = 'ACTIVE_LEGACY',
  CANCELED = 'CANCELED',
  CANCELED_LEGACY = 'CANCELED_LEGACY',
  NOT_STARTED = 'NOT_STARTED',
  OTHER = 'OTHER',
  PENDING = 'PENDING'
}

export enum Sort {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface StandardOrderEntry extends GenericOrderEntry {
  __typename?: 'StandardOrderEntry';
  comboChildren?: Maybe<Array<GenericOrderEntry>>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  discount?: Maybe<Discount>;
  entryNumber: Scalars['Int']['output'];
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  invoiceStatus?: Maybe<InvoiceStatus>;
  ipiTax?: Maybe<Money>;
  isHeaderPolicyDiscountExceeded?: Maybe<Scalars['Boolean']['output']>;
  isItemPolicyDiscountExceeded?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Product>;
  itemCategoryGroup?: Maybe<Scalars['String']['output']>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  listPrice?: Maybe<Money>;
  priceUnit?: Maybe<SalesUnit>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rejectionStatus?: Maybe<OrderEntryRejectionStatus>;
  salesUnit?: Maybe<SalesUnit>;
  shippedQuantity?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Money>;
  unitPrice?: Maybe<Money>;
  usagePeriod?: Maybe<Scalars['Int']['output']>;
}

export interface StandardOrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface StandardPrice {
  __typename?: 'StandardPrice';
  price: Scalars['BigDecimal']['output'];
  quantity: Scalars['Float']['output'];
  unit: SalesUnit;
}

export interface StandardPriceDetails {
  __typename?: 'StandardPriceDetails';
  listPriceInformation?: Maybe<StandardPrice>;
  salesPriceInformation?: Maybe<StandardPrice>;
  unitPriceInformation?: Maybe<StandardPrice>;
}

export interface StandardQuotation extends GenericOrder, Node, Pageable {
  __typename?: 'StandardQuotation';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<StandardOrderEntry>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  id: Scalars['ID']['output'];
  ipiTax?: Maybe<Money>;
  isConsumableSubscription?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Flag for distinguishing fleet and standard quotations for ByD markets.
   * To be replaced with query returning FleetQuotation and StandardQuotation types together after MVP and integration in cloud with contract interface
   */
  isFleet?: Maybe<Scalars['Boolean']['output']>;
  isForContract?: Maybe<Scalars['Boolean']['output']>;
  isHeaderPolicyDiscountExceeded?: Maybe<Scalars['Boolean']['output']>;
  isItemPolicyDiscountExceeded?: Maybe<Scalars['Boolean']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  salesChannel?: Maybe<SalesChannel>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  soldTo?: Maybe<Customer>;
  status?: Maybe<QuotationStatus>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<OrderType>;
}

export interface StandardQuotationPaginationResult extends PaginationResult {
  __typename?: 'StandardQuotationPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<StandardQuotation>>;
}

export interface StockAvailabilityFilterInput {
  plants: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  requestedQuantity: Scalars['Int']['input'];
}

export interface StockLevel {
  __typename?: 'StockLevel';
  plantId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  stockStatus?: Maybe<StockLevelStatus>;
}

export interface StockLevels {
  __typename?: 'StockLevels';
  product?: Maybe<Product>;
  results?: Maybe<Array<StockLevel>>;
}

export interface StockLevelsProductArgs {
  localization: LocalizationInput;
}

export enum StockLevelStatus {
  MATERIAL_NOT_AVAILABLE = 'MATERIAL_NOT_AVAILABLE',
  NOT_SUFFICIENT_AMOUNT_AVAILABLE = 'NOT_SUFFICIENT_AMOUNT_AVAILABLE',
  REQUIRED_AMOUNT_AVAILABLE = 'REQUIRED_AMOUNT_AVAILABLE',
  UNKNOWN_AVAILABILITY = 'UNKNOWN_AVAILABILITY'
}

export interface StoreConfiguration extends Node {
  __typename?: 'StoreConfiguration';
  checkout?: Maybe<CheckoutStoreConfiguration>;
  common?: Maybe<CommonStoreConfiguration>;
  fleet?: Maybe<FleetStoreConfiguration>;
  id: Scalars['ID']['output'];
  toolParkManagement?: Maybe<TpmStoreConfiguration>;
}

export interface StoreSearchFilterInput {
  includePickupDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface StoreSearchLocalizationInput {
  country?: InputMaybe<Scalars['String']['input']>;
  requestedUnit?: InputMaybe<DistanceUnit>;
}

export interface StoreSearchLocationInput {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}

export interface StoreSearchResult {
  __typename?: 'StoreSearchResult';
  distance?: Maybe<Scalars['Float']['output']>;
  hiltiCenter: HiltiCenter;
  unit?: Maybe<DistanceUnit>;
}

export interface StoreSearchResults {
  __typename?: 'StoreSearchResults';
  stores?: Maybe<Array<StoreSearchResult>>;
}

export interface SubmitGuestOrderBillingAddressInput {
  fullName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  town: Scalars['String']['input'];
}

export interface SubmitGuestOrderInput {
  billingAddress: SubmitGuestOrderBillingAddressInput;
  creditCardDetails?: InputMaybe<UpdateRapidPayCreditCardDetailsInput>;
  orderDraftId: Scalars['ID']['input'];
  shippingAddress: SubmitGuestOrderShippingAddressInput;
}

export interface SubmitGuestOrderPayload {
  __typename?: 'SubmitGuestOrderPayload';
  internalOrderId: Scalars['ID']['output'];
}

export interface SubmitGuestOrderShippingAddressInput {
  additionalTaxNumber?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  town: Scalars['String']['input'];
}

export interface SubmitOrderInput {
  carrierInstructions?: InputMaybe<Scalars['String']['input']>;
  creditCardDetails?: InputMaybe<UpdateRapidPayCreditCardDetailsInput>;
  orderDraftId: Scalars['ID']['input'];
  paymentTransactionId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsAccepted: Scalars['Boolean']['input'];
}

export interface SubmitOrderPayload {
  __typename?: 'SubmitOrderPayload';
  internalOrderId: Scalars['ID']['output'];
}

export interface SubscriptionActivationEContractIframeUrlInput {
  returnUri: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
}

export interface SubscriptionPrice {
  __typename?: 'SubscriptionPrice';
  monthlyPrice: Scalars['BigDecimal']['output'];
  unit?: Maybe<SalesUnit>;
  yearlyPrice: Scalars['BigDecimal']['output'];
}

export interface SubscriptionPriceDetails {
  __typename?: 'SubscriptionPriceDetails';
  billingType: BillingCycle;
  salesPriceInformation: SubscriptionPrice;
  unitPriceInformation: SubscriptionPrice;
}

export interface SubscriptionProratedCharges {
  __typename?: 'SubscriptionProratedCharges';
  currentProrate?: Maybe<Money>;
  prorate?: Maybe<Money>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
}

export interface TargetedCampaignEVoucherDetails {
  __typename?: 'TargetedCampaignEVoucherDetails';
  accountsFileName?: Maybe<Scalars['String']['output']>;
  numberOfAccounts?: Maybe<Scalars['Int']['output']>;
  numberOfContacts?: Maybe<Scalars['Int']['output']>;
}

export interface TemporarilyBanBannerInput {
  bannerId: Scalars['String']['input'];
  journeyId: Scalars['UUID']['input'];
}

export interface TemporarilyBanBannerPayload {
  __typename?: 'TemporarilyBanBannerPayload';
  journeyId: Scalars['UUID']['output'];
}

export interface TimeRange {
  __typename?: 'TimeRange';
  /** End time as a String with the following format  HH:MM:SS */
  end?: Maybe<Scalars['String']['output']>;
  /** Start time as a String with the following format  HH:MM:SS */
  start?: Maybe<Scalars['String']['output']>;
}

export interface Tool extends Node, Pageable {
  __typename?: 'Tool';
  age?: Maybe<Scalars['Int']['output']>;
  comboChildren?: Maybe<Array<Maybe<Tool>>>;
  comboType?: Maybe<ToolComboType>;
  equipmentNumber?: Maybe<Scalars['String']['output']>;
  exchangeDetails?: Maybe<ToolExchangeDetails>;
  fleetDetails?: Maybe<FleetDetails>;
  generation?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ToolGroup>;
  /** Tool has the following pattern TID-materialNumber-serialNumber */
  id: Scalars['ID']['output'];
  location?: Maybe<GeoLocation>;
  originEquipmentNumber?: Maybe<Scalars['String']['output']>;
  peakDetails?: Maybe<ToolPeakDetails>;
  product?: Maybe<Product>;
  purchaseDetails?: Maybe<ToolPurchaseDetails>;
  repairDetails?: Maybe<ToolRepairDetails>;
  salesOrderDetails?: Maybe<ToolSalesOrderDetails>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ToolStatus>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface ToolProductArgs {
  localization: LocalizationInput;
}

export enum ToolComboType {
  BOM = 'BOM',
  SNT = 'SNT'
}

export interface ToolDefect extends Localizable {
  __typename?: 'ToolDefect';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface ToolDefectNameArgs {
  localization: LocalizationInput;
}

export interface ToolDefectInformation {
  __typename?: 'ToolDefectInformation';
  defect: ToolDefect;
  toolPart?: Maybe<ToolDefect>;
}

export interface ToolDocument {
  __typename?: 'ToolDocument';
  size?: Maybe<Scalars['Int']['output']>;
  type: ToolDocumentType;
  uri?: Maybe<Scalars['String']['output']>;
}

export enum ToolDocumentType {
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  REPAIR_CERTIFICATE = 'REPAIR_CERTIFICATE'
}

export interface ToolExchangeDetails {
  __typename?: 'ToolExchangeDetails';
  exchangeStatus?: Maybe<ToolExchangeStatus>;
  hasFollowUpProposals?: Maybe<Scalars['Boolean']['output']>;
}

export enum ToolExchangeStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  REPLACEMENT_REQUIRED = 'REPLACEMENT_REQUIRED'
}

export interface ToolFilters {
  __typename?: 'ToolFilters';
  costCenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<ToolGroup>>>;
  inventoryNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organizationalReferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statuses?: Maybe<Array<Maybe<ToolStatus>>>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface ToolFiltersInput {
  costCenter?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<ToolGroup>>>;
  inventoryNumber?: InputMaybe<Scalars['String']['input']>;
  organizationalReference?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ToolStatus>>>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export enum ToolGroup {
  FLEET = 'FLEET',
  LOAN = 'LOAN',
  PEAK = 'PEAK',
  PURCHASED = 'PURCHASED'
}

export enum ToolListColumn {
  CONTRACT_END_DATE = 'CONTRACT_END_DATE',
  CONTRACT_START_DATE = 'CONTRACT_START_DATE',
  CONTRACT_TYPE = 'CONTRACT_TYPE',
  COST_CENTER = 'COST_CENTER',
  EQUIPMENT_NUMBER = 'EQUIPMENT_NUMBER',
  GENERATION = 'GENERATION',
  GROUP = 'GROUP',
  INVENTORY_NUMBER = 'INVENTORY_NUMBER',
  LAST_REPAIR_DATE = 'LAST_REPAIR_DATE',
  LOAN_TOOL_OPTION = 'LOAN_TOOL_OPTION',
  MATERIAL_NUMBER = 'MATERIAL_NUMBER',
  MONTHLY_FEE = 'MONTHLY_FEE',
  NO_COST_EXPIRY_DATE = 'NO_COST_EXPIRY_DATE',
  NUMBER_OF_REPAIRS = 'NUMBER_OF_REPAIRS',
  ORGANIZATIONAL_REFERENCE = 'ORGANIZATIONAL_REFERENCE',
  PEAK_CONTRACT_END_DATE = 'PEAK_CONTRACT_END_DATE',
  PEAK_CONTRACT_START_DATE = 'PEAK_CONTRACT_START_DATE',
  PURCHASE_DATE = 'PURCHASE_DATE',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER',
  REPAIR_COST = 'REPAIR_COST',
  REPLACEMENT_TOOL = 'REPLACEMENT_TOOL',
  SALES_ORDER_ID = 'SALES_ORDER_ID',
  SERIAL_NUMBER = 'SERIAL_NUMBER',
  STATUS = 'STATUS',
  THEFT_COVERAGE_OPTION = 'THEFT_COVERAGE_OPTION',
  TOOL_DETAILS = 'TOOL_DETAILS',
  TOOL_IMAGE = 'TOOL_IMAGE',
  TOTAL_USAGE_PERIOD = 'TOTAL_USAGE_PERIOD',
  WARRANTY = 'WARRANTY'
}

export interface ToolPeakDetails {
  __typename?: 'ToolPeakDetails';
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  contractStartDate?: Maybe<Scalars['Date']['output']>;
}

export interface ToolPurchaseDetails {
  __typename?: 'ToolPurchaseDetails';
  underWarranty?: Maybe<Scalars['Boolean']['output']>;
  warrantyEndDate?: Maybe<Scalars['Date']['output']>;
}

export interface ToolRepairDetails {
  __typename?: 'ToolRepairDetails';
  lastRepairDate?: Maybe<Scalars['Date']['output']>;
  numberOfRepairs?: Maybe<Scalars['Int']['output']>;
  repairCost?: Maybe<Money>;
}

export enum ToolRepairField {
  NUMBER_OF_PACKAGES = 'NUMBER_OF_PACKAGES',
  PURCHASE_ORDER_DOCUMENT = 'PURCHASE_ORDER_DOCUMENT',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER'
}

export enum ToolReturnMethod {
  PICKUP = 'PICKUP',
  SHIPPING_LABEL = 'SHIPPING_LABEL'
}

export interface ToolSalesOrderDetails {
  __typename?: 'ToolSalesOrderDetails';
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
}

export interface ToolsFilterInput {
  contractEndDateFrom?: InputMaybe<Scalars['Date']['input']>;
  contractEndDateTo?: InputMaybe<Scalars['Date']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<ToolGroup>>>;
  hasFollowUpProposals?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryNumber?: InputMaybe<Scalars['String']['input']>;
  organizationalReference?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ToolStatus>>>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export interface ToolsOrderByInput {
  contractEndDate?: InputMaybe<Sort>;
  contractStartDate?: InputMaybe<Sort>;
  costCenter?: InputMaybe<Sort>;
  group?: InputMaybe<Sort>;
  inventoryNumber?: InputMaybe<Sort>;
  lastRepairDate?: InputMaybe<Sort>;
  organizationalReference?: InputMaybe<Sort>;
  peakContractEndDate?: InputMaybe<Sort>;
  peakContractStartDate?: InputMaybe<Sort>;
  salesOrderDate?: InputMaybe<Sort>;
  salesOrderId?: InputMaybe<Sort>;
  serialNumber?: InputMaybe<Sort>;
}

export interface ToolsPaginationResult extends PaginationResult {
  __typename?: 'ToolsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Tool>>;
}

export interface ToolsProcessPayload {
  __typename?: 'ToolsProcessPayload';
  status?: Maybe<ToolsProcessStatus>;
}

export enum ToolsProcessStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum ToolStatus {
  ACTIVE = 'ACTIVE',
  AWAITING_NEW_PRODUCT = 'AWAITING_NEW_PRODUCT',
  COLLECTED = 'COLLECTED',
  ERROR = 'ERROR',
  FLEET_IN_EXTENSION = 'FLEET_IN_EXTENSION',
  FORMER_FLEET_TOOL = 'FORMER_FLEET_TOOL',
  IN_SPECIAL_EXTENSION = 'IN_SPECIAL_EXTENSION',
  LOST = 'LOST',
  NOT_COLLECTED = 'NOT_COLLECTED',
  PEAK_EXTENSION = 'PEAK_EXTENSION',
  SELF_RECYCLING = 'SELF_RECYCLING',
  STOLEN = 'STOLEN',
  TO_BE_COLLECTED = 'TO_BE_COLLECTED'
}

export interface ToolTrackingDetails {
  __typename?: 'ToolTrackingDetails';
  deliveryId?: Maybe<Scalars['String']['output']>;
  trackingDetails?: Maybe<ShipmentTrackingDetails>;
  trackingEvents?: Maybe<Array<ToolTrackingEvent>>;
}

export interface ToolTrackingDetailsTrackingDetailsArgs {
  localization: LocalizationInput;
}

export interface ToolTrackingEvent {
  __typename?: 'ToolTrackingEvent';
  estimatedDateFrom?: Maybe<Scalars['DateTime']['output']>;
  estimatedDateTo?: Maybe<Scalars['DateTime']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  status: ToolTrackingStatus;
}

export enum ToolTrackingStatus {
  EXPECT_DELAYS = 'EXPECT_DELAYS',
  FAILED_DELIVERY = 'FAILED_DELIVERY',
  GRACE_PERIOD_STARTED = 'GRACE_PERIOD_STARTED',
  IN_TRANSIT = 'IN_TRANSIT',
  LOAN_TOOL_ARRIVED = 'LOAN_TOOL_ARRIVED',
  ORDER_RECEIVED = 'ORDER_RECEIVED',
  PICK_UP = 'PICK_UP',
  PICK_UP_DELAYED = 'PICK_UP_DELAYED',
  PICK_UP_FAILED = 'PICK_UP_FAILED',
  PICK_UP_PLANNED = 'PICK_UP_PLANNED',
  PTP_TOOL_RETURNED = 'PTP_TOOL_RETURNED',
  RENTAL_BILLING_STARTED = 'RENTAL_BILLING_STARTED',
  RETURNED = 'RETURNED',
  TOOL_DISPATCHED = 'TOOL_DISPATCHED'
}

export interface ToolTradeInQuotationDetails {
  __typename?: 'ToolTradeInQuotationDetails';
  monthlyFee?: Maybe<Money>;
  replacementProduct?: Maybe<Product>;
  standardPrice?: Maybe<Money>;
}

export interface ToolTradeInQuotationDetailsReplacementProductArgs {
  localization: LocalizationInput;
}

export interface TpmStoreConfiguration {
  __typename?: 'TPMStoreConfiguration';
  additionalPackagingDays?: Maybe<Scalars['Int']['output']>;
  circularityReports?: Maybe<Scalars['Boolean']['output']>;
  employeeChangeCostCenterToolProcess?: Maybe<Scalars['Boolean']['output']>;
  employeeFleetExchangeExtendToolProcess?: Maybe<Scalars['Boolean']['output']>;
  employeeFleetExchangeRenewToolProcess?: Maybe<Scalars['Boolean']['output']>;
  employeeFleetExchangeReturnToolProcess?: Maybe<Scalars['Boolean']['output']>;
  employeeReorderLabelsToolProcess?: Maybe<Scalars['Boolean']['output']>;
  employeeReturnToolProcess?: Maybe<Scalars['Boolean']['output']>;
  fleetExchangeExtendToolProcess?: Maybe<Scalars['Boolean']['output']>;
  fleetExchangeRenewToolProcess?: Maybe<Scalars['Boolean']['output']>;
  fleetExchangeToolProcess?: Maybe<Scalars['Boolean']['output']>;
  fleetPurchaseReturnDangerousToolProcess?: Maybe<Scalars['Boolean']['output']>;
  loanPeakReturnDangerousToolProcess?: Maybe<Scalars['Boolean']['output']>;
  loanToolProcess?: Maybe<Scalars['Boolean']['output']>;
  lostStolenToolProcess?: Maybe<Scalars['Boolean']['output']>;
  lostToolsOathDeclarationRequired?: Maybe<Scalars['Boolean']['output']>;
  peakToolProcess?: Maybe<Scalars['Boolean']['output']>;
  repairTrackingProcess?: Maybe<Scalars['Boolean']['output']>;
  returnToolProcess?: Maybe<Scalars['Boolean']['output']>;
  showPickUpDate?: Maybe<Scalars['Boolean']['output']>;
  showRepairTrackingDates?: Maybe<Scalars['Boolean']['output']>;
  stolenToolsPoliceReportFileExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stolenToolsPoliceReportRequired?: Maybe<Scalars['Boolean']['output']>;
  toolDocumentsDownload?: Maybe<Scalars['Boolean']['output']>;
  toolListColumns?: Maybe<Array<Maybe<ToolListColumn>>>;
  toolParkManagement?: Maybe<Scalars['Boolean']['output']>;
  toolPickupAndDeliveryOptions?: Maybe<Scalars['Boolean']['output']>;
  /** Collection of fields that are displayed on repair tracking, repair, exchange and return processes */
  toolRepairFields?: Maybe<Array<ToolRepairField>>;
}

export interface TradeInAndRecycleToolsForRepairNotificationsInput {
  repairNotificationIds: Array<Scalars['String']['input']>;
}

export interface TransferSoftwareSubscriptionAdminRightsInput {
  adminContactOriginId: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
  subscriptionVersion?: InputMaybe<Scalars['Int']['input']>;
}

export interface TransferSoftwareSubscriptionAdminRightsPayload {
  __typename?: 'TransferSoftwareSubscriptionAdminRightsPayload';
  adminContact: Contact;
  subscriptionId: Scalars['ID']['output'];
}

export interface UnassignSoftwareSubscriptionContactInput {
  email: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
}

export interface UnassignSoftwareSubscriptionContactPayload {
  __typename?: 'UnassignSoftwareSubscriptionContactPayload';
  email?: Maybe<Scalars['String']['output']>;
}

export interface UnassignSoftwareSubscriptionContactsInput {
  emails: Array<Scalars['String']['input']>;
  licenseActivationCode: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
}

export interface UnassignSoftwareSubscriptionContactsPayload {
  __typename?: 'UnassignSoftwareSubscriptionContactsPayload';
  emails: Array<Maybe<Scalars['String']['output']>>;
}

export interface UnitOfMeasure extends Localizable {
  __typename?: 'UnitOfMeasure';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface UnitOfMeasureNameArgs {
  localization: LocalizationInput;
}

export interface UpdateCampaignEVoucherInput {
  conditionTiers: Array<UpdateCampaignEVoucherTierInput>;
  eligibleProducts?: InputMaybe<UpdateCampaignEVoucherProductsSelectionInput>;
  eVoucherCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maxNumberOfRedemptions?: InputMaybe<Scalars['Int']['input']>;
  nonTargetedRedemptionRules?: InputMaybe<NonTargetedRedemptionRulesInput>;
  qualifyingProducts?: InputMaybe<UpdateCampaignEVoucherProductsSelectionInput>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
}

export interface UpdateCampaignEVoucherPayload {
  __typename?: 'UpdateCampaignEVoucherPayload';
  eVoucher: EVoucher;
}

export interface UpdateCampaignEVoucherProductSelectionInput {
  id: Scalars['String']['input'];
  type: EVoucherProductSelectionType;
}

export interface UpdateCampaignEVoucherProductsSelectionInput {
  excludedProducts?: InputMaybe<Array<UpdateCampaignEVoucherProductSelectionInput>>;
  includedProducts?: InputMaybe<Array<UpdateCampaignEVoucherProductSelectionInput>>;
}

export interface UpdateCampaignEVoucherTierInput {
  cartTotal?: InputMaybe<Scalars['BigDecimal']['input']>;
  discountPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  discountValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  productsValue?: InputMaybe<Scalars['BigDecimal']['input']>;
}

export interface UpdateContactInput {
  academicTitle?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  function: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateContactPayload {
  __typename?: 'UpdateContactPayload';
  contact?: Maybe<Contact>;
}

export interface UpdateEContractInput {
  eContractId: Scalars['ID']['input'];
  eContractView: EContractViewInput;
  templateId: Scalars['String']['input'];
}

export interface UpdateFleetMasterContractInput {
  exchangeCycle?: InputMaybe<ExchangeCycle>;
  exchangeMonth?: InputMaybe<Scalars['Int']['input']>;
  fleetLabelingTemplateId?: InputMaybe<Scalars['String']['input']>;
  invoiceGroupedBy?: InputMaybe<InvoiceOption>;
  invoiceSplitBy?: InputMaybe<InvoiceOption>;
  masterContractId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateFleetQuotationEntryInput {
  costCenter?: InputMaybe<Scalars['String']['input']>;
  entryNumber: Scalars['Int']['input'];
  inventoryNumber?: InputMaybe<Scalars['String']['input']>;
  organizationalReference?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateFleetQuotationInput {
  billToAccountOriginId?: InputMaybe<Scalars['String']['input']>;
  carrierInstructions?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['Date']['input']>;
  entries?: InputMaybe<Array<InputMaybe<UpdateFleetQuotationEntryInput>>>;
  fleetEContractId?: InputMaybe<Scalars['String']['input']>;
  fleetLabelingTemplateId?: InputMaybe<Scalars['String']['input']>;
  fleetMasterContract?: InputMaybe<UpdateFleetMasterContractInput>;
  isSingleShipment?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  quotationId: Scalars['ID']['input'];
  shipToAccountOriginId?: InputMaybe<Scalars['String']['input']>;
  shipToContactOriginId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateFleetQuotationPayload {
  __typename?: 'UpdateFleetQuotationPayload';
  quotationId: Scalars['ID']['output'];
}

export interface UpdateMarketingConsentsInput {
  consents?: InputMaybe<Array<MarketingConsentInput>>;
  legalText?: InputMaybe<Scalars['String']['input']>;
  sourceOfChange: MarketingConsentSource;
}

export interface UpdateMarketingConsentsPayload {
  __typename?: 'UpdateMarketingConsentsPayload';
  status: MarketingConsentUpdateStatus;
}

export interface UpdateOrderDraftBillToAccountInput {
  billToId: Scalars['String']['input'];
  orderDraftId: Scalars['ID']['input'];
}

export interface UpdateOrderDraftDeliveryMethodInput {
  deliveryMethodId: Scalars['String']['input'];
  orderDraftId: Scalars['ID']['input'];
  requestedDeliveryDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface UpdateOrderDraftEntryPaymentMethodInput {
  entryType: OrderDraftEntryType;
  orderDraftId: Scalars['ID']['input'];
  paymentMethodCode: Scalars['String']['input'];
}

export interface UpdateOrderDraftPayload {
  __typename?: 'UpdateOrderDraftPayload';
  orderDraft: OrderDraft;
}

export interface UpdateOrderDraftPurchaseOrderNumberInput {
  orderDraftId: Scalars['ID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
}

export interface UpdateOrderDraftShipToAccountInput {
  orderDraftId: Scalars['ID']['input'];
  shipToAccountId: Scalars['String']['input'];
}

export interface UpdateOrderDraftShipToContactInput {
  orderDraftId: Scalars['ID']['input'];
  shipToContactId: Scalars['String']['input'];
}

export interface UpdateOrderDraftShipToHiltiCenterInput {
  hiltiCenterId: Scalars['String']['input'];
  orderDraftId: Scalars['ID']['input'];
}

export interface UpdatePurchaseRequestPayload {
  __typename?: 'UpdatePurchaseRequestPayload';
  id: Scalars['ID']['output'];
}

export interface UpdateRapidPayCreditCardDetailsInput {
  authentication?: InputMaybe<VerifyRapidPayCreditCardAuthenticationInput>;
  authorization: Scalars['JWT']['input'];
}

export interface UpdateRepairNotificationPayload {
  __typename?: 'UpdateRepairNotificationPayload';
  repairNotificationId: Scalars['ID']['output'];
}

export interface UpdateRepairNotificationShippingDetailsInput {
  carrierInstructions?: InputMaybe<Scalars['String']['input']>;
  repairNotificationId: Scalars['String']['input'];
  shippingAddressOriginId: Scalars['String']['input'];
  shippingContactOriginId: Scalars['String']['input'];
}

export interface UpdateShoppingListInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface UpdateShoppingListItemInput {
  itemId: Scalars['ID']['input'];
  itemPosition: Scalars['Int']['input'];
}

export interface UpdateShoppingListItemPayload {
  __typename?: 'UpdateShoppingListItemPayload';
  itemId: Scalars['ID']['output'];
}

export interface UpdateShoppingListItemPurchaseTypeInput {
  itemId: Scalars['ID']['input'];
  purchaseType: ShoppingListItemPurchaseType;
  shoppingListId: Scalars['ID']['input'];
}

export interface UpdateShoppingListItemQuantityInput {
  itemId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  shoppingListId: Scalars['ID']['input'];
}

export interface UpdateShoppingListItemsPayload {
  __typename?: 'UpdateShoppingListItemsPayload';
  items: Array<Maybe<UpdateShoppingListItemPayload>>;
}

export interface UpdateShoppingListItemsPositionInput {
  items: Array<InputMaybe<UpdateShoppingListItemInput>>;
  shoppingListId: Scalars['ID']['input'];
}

export interface UpdateShoppingListPayload {
  __typename?: 'UpdateShoppingListPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface UpdateSoftwareSubscriptionPurchaseOrderNumberInput {
  purchaseOrderNumber: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}

export interface UpdateSoftwareSubscriptionPurchaseOrderNumberPayload {
  __typename?: 'UpdateSoftwareSubscriptionPurchaseOrderNumberPayload';
  softwareSubscription?: Maybe<SoftwareSubscription>;
}

export interface UpdateSoftwareSubscriptionRapidPayCreditCardDetailsInput {
  creditCardDetails?: InputMaybe<UpdateRapidPayCreditCardDetailsInput>;
  subscriptionId: Scalars['ID']['input'];
  subscriptionVersion: Scalars['Int']['input'];
}

export interface UpdateSoftwareSubscriptionRapidPayCreditCardDetailsPayload {
  __typename?: 'UpdateSoftwareSubscriptionRapidPayCreditCardDetailsPayload';
  softwareSubscription: SoftwareSubscription;
}

export interface User extends Node, UserContext {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Will not be supported in the future. */
  registrationCompanyAccount?: Maybe<RegistrationCompanyAccount>;
  /** @deprecated Will not be supported in the future. */
  registrationContact?: Maybe<RegistrationContact>;
}

/** This interface is designed to be used for Customer, User and Employee. */
export interface UserContext {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
}

export interface ValidatePurchaseOrderNumberInput {
  /** This field is the originId until the full migration of CCMSv2 would be finalized */
  billingAddressId: Scalars['String']['input'];
  orderTypeId: Scalars['String']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
}

export interface ValidatePurchaseOrderNumberPayload {
  __typename?: 'ValidatePurchaseOrderNumberPayload';
  validationStatus: ValidationStatus;
}

export enum ValidationStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED'
}

export interface VerifyRapidPayCreditCardAuthenticationInput {
  accessToken: Scalars['JWT']['input'];
  authentication: Scalars['String']['input'];
  tokenization: Scalars['JWT']['input'];
}

export interface VerifyRapidPayCreditCardAuthenticationPayload {
  __typename?: 'VerifyRapidPayCreditCardAuthenticationPayload';
  authenticationDetails?: Maybe<Scalars['JSON']['output']>;
}

export interface Warehouse extends Node {
  __typename?: 'Warehouse';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface WarehouseSearchFilterInput {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface WarehouseSearchResults {
  __typename?: 'WarehouseSearchResults';
  results?: Maybe<Array<Warehouse>>;
}

export interface WebAnalyticsData {
  __typename?: 'WebAnalyticsData';
  trackCreative?: Maybe<Scalars['String']['output']>;
  trackId?: Maybe<Scalars['String']['output']>;
  trackName?: Maybe<Scalars['String']['output']>;
}

export interface Webinar extends Node {
  __typename?: 'Webinar';
  /** Accreditor details for the webinar */
  accreditor?: Maybe<Accreditor>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  sessionDetails?: Maybe<WebinarSessionDetails>;
  /** The part of the URL that identifies the particular webinar in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface WebinarSessionDetails {
  __typename?: 'WebinarSessionDetails';
  count?: Maybe<Scalars['Int']['output']>;
  nextSessionStartsAt?: Maybe<Scalars['DateTime']['output']>;
  nextSessionTimezone?: Maybe<Scalars['TimeZone']['output']>;
}

export interface WeeklyOpeningSchedule {
  __typename?: 'WeeklyOpeningSchedule';
  days?: Maybe<Array<DailyOpeningSchedule>>;
  open?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['TimeZone']['output']>;
}
